export enum PhysicalExamCodes {
  Normocephalic = "forms/physicalExam/heent/normocephalic",
  Atraumatic = "forms/physicalExam/heent/atraumatic",
  NoVisibleOrPalpableMassesDepressionsOrScarring = "forms/physicalExam/heent/no-visible-or-palpable-masses-depressions-or-scarring",
  MassesPresent = "forms/physicalExam/heent/masses-present",
  ScarringPresent = "forms/physicalExam/heent/scarring-present",
  ConjunctivaClear = "forms/physicalExam/heent/conjunctiva-clear",
  ScleraNonIcteric = "forms/physicalExam/heent/sclera-non-icteric",
  EOMIntact = "forms/physicalExam/heent/eom-intact",
  PERRL = "forms/physicalExam/heent/perrl",
  NoExudatesOrHemorrhages = "forms/physicalExam/heent/no-exudates-or-hemorrhages",
  VisualAcuityIntact = "forms/physicalExam/heent/visual-acuity-intact",
  WearingGlasses = "forms/physicalExam/heent/wearing-glasses",
  WearingContactLenses = "forms/physicalExam/heent/wearing-contact-lenses",
  DischargePresent = "forms/physicalExam/heent/discharge-present",
  IctericSclera = "forms/physicalExam/heent/icteric-sclera",
  CataractsPresent = "forms/physicalExam/heent/cataracts-present",
  MissingEyes = "forms/physicalExam/heent/missing-eyes",
  HearingIntact = "forms/physicalExam/heent/hearing-intact",
  EACsClear = "forms/physicalExam/heent/eacs-clear",
  TympanicMembraneTranslucentMobile = "forms/physicalExam/heent/tympanic-membrane-translucent-mobile",
  NoDeformities = "forms/physicalExam/heent/no-deformities",
  DifficultyHearing = "forms/physicalExam/heent/difficulty-hearing",
  TympanicMembraneBulging = "forms/physicalExam/heent/tympanic-membrane-bulging",
  ExcessiveEarWaxPresent = "forms/physicalExam/heent/excessive-ear-wax-present",
  HearingAidPresent = "forms/physicalExam/heent/hearing-aid-present",
  DeformitiesPresent = "forms/physicalExam/heent/deformities-present",
  PatentNares = "forms/physicalExam/heent/patent-nares",
  NoExternalLesions = "forms/physicalExam/heent/no-external-lesions",
  MucosaNonInflamed = "forms/physicalExam/heent/mucosa-non-inflamed",
  StraightSeptum = "forms/physicalExam/heent/straight-septum",
  FlaringOfNares = "forms/physicalExam/heent/flaring-of-nares",
  DeviatedSeptum = "forms/physicalExam/heent/deviated-septum",
  NonPatentNare = "forms/physicalExam/heent/non-patent-nare",
  MucousMembranesPink = "forms/physicalExam/heent/mucous-membranes-pink",
  MucousMembranesMoist = "forms/physicalExam/heent/mucous-membranes-moist",
  NoMucosalLesions = "forms/physicalExam/heent/no-mucosal-lesions",
  DryChappedLips = "forms/physicalExam/heent/dry-chapped-lips",
  LesionOfLips = "forms/physicalExam/heent/lesion-of-lips",
  LesionOfInsideOfMouth = "forms/physicalExam/heent/lesion-of-inside-of-mouth",
  PallorOfMucousMembranes = "forms/physicalExam/heent/pallor-of-mucous-membranes",
  CleftPalate = "forms/physicalExam/heent/cleft-palate",
  Halitosis = "forms/physicalExam/heent/halitosis",
  AllMostTeethPresent = "forms/physicalExam/heent/all-most-teeth-present",
  NoObviousCariesOrPeriodontalDisease = "forms/physicalExam/heent/no-obvious-caries-or-periodontal-disease",
  NoGingivalInflammationOrSignificantResorption = "forms/physicalExam/heent/no-gingival-inflammation-or-significant-resorption",
  TeethMissing = "forms/physicalExam/heent/teeth-missing",
  Dentures = "forms/physicalExam/heent/dentures",
  BleedingGums = "forms/physicalExam/heent/bleeding-gums",
  RecedingGums = "forms/physicalExam/heent/receding-gums",
  NoTonsillarHypertrophyOrExudate = "forms/physicalExam/heent/no-tonsillar-hypertrophy-or-exudate",
  ExudatePresentInPharynx = "forms/physicalExam/heent/exudate-present-in-pharynx",
  ExudatePresentOnTonsils = "forms/physicalExam/heent/exudate-present-on-tonsils",
  EnlargedTonsils = "forms/physicalExam/heent/enlarged-tonsils",
  ThyroidNonEnlarged = "forms/physicalExam/heent/thyroid-non-enlarged",
  ThyroidNonTender = "forms/physicalExam/heent/thyroid-non-tender",
  ThyroidWithoutMasses = "forms/physicalExam/heent/thyroid-without-masses",
  Supple = "forms/physicalExam/heent/supple",
  TracheaMidline = "forms/physicalExam/heent/trachea-midline",
  NoLesionsBruitsOrAdenopathy = "forms/physicalExam/heent/no-lesions-bruits-or-adenopathy",
  ThyroidEnlarged = "forms/physicalExam/heent/thyroid-enlarged",
  ThyroidNodules = "forms/physicalExam/heent/thyroid-nodules",
  ThyroidTenderness = "forms/physicalExam/heent/thyroid-tenderness",
  PainWithMotion = "forms/physicalExam/heent/pain-with-motion",
  NeckTenderness = "forms/physicalExam/heent/neck-tenderness",
  EnlargedLymphNodes = "forms/physicalExam/heent/enlarged-lymph-nodes",
  Rigid = "forms/physicalExam/heent/rigid",
  DeviatedTrachea = "forms/physicalExam/heent/deviated-trachea",
  WellAppearing = "forms/physicalExam/general/well-appearing",
  WellNourished = "forms/physicalExam/general/well-nourished",
  WellDeveloped = "forms/physicalExam/general/well-developed",
  NoAcuteDistress = "forms/physicalExam/general/no-acute-distress",
  AlertAndOrientedX3 = "forms/physicalExam/general/alert-and-oriented-x-3",
  NormalMoodAffect = "forms/physicalExam/general/normal-mood-affect",
  Distressed = "forms/physicalExam/general/distressed",
  Disheveled = "forms/physicalExam/general/disheveled",
  Lethargic = "forms/physicalExam/general/lethargic",
  Underdeveloped = "forms/physicalExam/general/underdeveloped",
  Overdeveloped = "forms/physicalExam/general/overdeveloped",
  NotAlert = "forms/physicalExam/general/not-alert",
  NotOrientedTime = "forms/physicalExam/general/not-oriented-time",
  NotOrientedPlace = "forms/physicalExam/general/not-oriented-place",
  NotOrientedPerson = "forms/physicalExam/general/not-oriented-person",
  BreastSmoothSkin = "forms/physicalExam/breast/smooth-skin",
  BreastNoNippleAbnormality = "forms/physicalExam/breast/no-nipple-abnormality",
  BreastNoDistinctMasses = "forms/physicalExam/breast/no-distinct-masses",
  BreastNoTendernessToPalpation = "forms/physicalExam/breast/no-tenderness-to-palpation",
  BreastNoAxillaryAdenopathy = "forms/physicalExam/breast/no-axillary-adenopathy",
  BreastNoNippleDischarge = "forms/physicalExam/breast/no-nipple-discharge",
  BreastNoScars = "forms/physicalExam/breast/no-scars",
  BreastNoEngorgement = "forms/physicalExam/breast/no-engorgement",
  BreastCurrentlyBreastfeeding = "forms/physicalExam/breast/currently-breastfeeding",
  BreastEngorgement = "forms/physicalExam/breast/engorgement",
  BreastRedness = "forms/physicalExam/breast/redness",
  BreastCrackedNipples = "forms/physicalExam/breast/cracked-nipples",
  BreastInvertedLNipple = "forms/physicalExam/breast/inverted-l-nipple",
  BreastInvertedRNipple = "forms/physicalExam/breast/inverted-r-nipple",
  BreastFibrocystic = "forms/physicalExam/breast/fibrocystic",
  BreastSkinDimpling = "forms/physicalExam/breast/skin-dimpling",
  BreastPeauDorange = "forms/physicalExam/breast/peau-dorange",
  BreastScarring = "forms/physicalExam/breast/scarring",
  BreastMasses = "forms/physicalExam/breast/masses",
  BreastBloodyRNippleDischarge = "forms/physicalExam/breast/bloody-r-nipple-discharge",
  BreastGreenYellowRNippleDischarge = "forms/physicalExam/breast/green-yellow-r-nipple-discharge",
  BreastClearRNippleDischarge = "forms/physicalExam/breast/clear-r-nipple-discharge",
  BreastWhiteMilkyRNippleDischarge = "forms/physicalExam/breast/white-milky-r-nipple-discharge",
  BreastBloodyLNippleDischarge = "forms/physicalExam/breast/bloody-l-nipple-discharge",
  BreastGreenYellowLNippleDischarge = "forms/physicalExam/breast/green-yellow-l-nipple-discharge",
  BreastClearLNippleDischarge = "forms/physicalExam/breast/clear-l-nipple-discharge",
  BreastWhiteMilkyLNippleDischarge = "forms/physicalExam/breast/white-milky-l-nipple-discharge",
  BreastAxillaryLymphNodesEnlarged = "forms/physicalExam/breast/axillary-lymph-nodes-enlarged",
  BreastSupraclavicularLymphNodesEnlarged = "forms/physicalExam/breast/supraclavicular-lymph-nodes-enlarged",
  DTRsNormal = "forms/physicalExam/neurologic/dtrs-normal",
  IntactSensations = "forms/physicalExam/neurologic/intact-sensations",
  DTRsPlus3 = "forms/physicalExam/neurologic/dtrs-plus-3",
  DTRsPlus4 = "forms/physicalExam/neurologic/dtrs-plus-4",
  DTRsPlus2 = "forms/physicalExam/neurologic/dtrs-plus-2",
  InabilityToDifferentiateHotFromCold = "forms/physicalExam/neurologic/inability-to-differentiate-hot-from-cold",
  InabilityToDifferentiateSharpFromDull = "forms/physicalExam/neurologic/inability-to-differentiate-sharp-from-dull",
  NormalRangeOfMotion = "forms/physicalExam/extremities/normal-range-of-motion",
  NoSwelling = "forms/physicalExam/extremities/no-swelling",
  NoTenderness = "forms/physicalExam/extremities/no-tenderness",
  NoCyanosis = "forms/physicalExam/extremities/no-cyanosis",
  NoClubbing = "forms/physicalExam/extremities/no-clubbing",
  CapillaryRefillLessThan2Seconds = "forms/physicalExam/extremities/capillary-refill-less-than-2-seconds",
  LimitedRangeOfMotion = "forms/physicalExam/extremities/limited-range-of-motion",
  Swelling = "forms/physicalExam/extremities/swelling",
  Tenderness = "forms/physicalExam/extremities/tenderness",
  Deformities = "forms/physicalExam/extremities/deformities",
  Cyanosis = "forms/physicalExam/extremities/cyanosis",
  Clubbing = "forms/physicalExam/extremities/clubbing",
  CapillaryRefillGreaterThan2Seconds = "forms/physicalExam/extremities/capillary-refill-greater-than-2-seconds",
  Edema = "forms/physicalExam/extremities/edema",
  JointStiffness = "forms/physicalExam/extremities/joint-stiffness",
  MuscleWeakness = "forms/physicalExam/extremities/muscle-weakness",
  MuscleAtrophy = "forms/physicalExam/extremities/muscle-atrophy",
  Tremors = "forms/physicalExam/extremities/tremors",
  VaricoseVeins = "forms/physicalExam/extremities/varicose-veins",
  RegularRateRhythm = "forms/physicalExam/heart/regular-rate-rhythm",
  NoMurmurGallop = "forms/physicalExam/heart/no-murmur-gallop",
  IrregularRhythm = "forms/physicalExam/heart/irregular-rhythm",
  IrregularRate = "forms/physicalExam/heart/irregular-rate",
  MurmurPresent = "forms/physicalExam/heart/murmur-present",
  Wheezing = "forms/physicalExam/lungs/wheezing",
  RalesCrackles = "forms/physicalExam/lungs/rales-crackles",
  LungsIrregularRate = "forms/physicalExam/lungs/irregular-rate",
  Rhonchi = "forms/physicalExam/lungs/rhonchi",
  UseOfAccessoryMuscles = "forms/physicalExam/lungs/use-of-accessory-muscles",
  SkinGoodTurgor = "forms/physicalExam/skin/good-turgor",
  SkinNoRash = "forms/physicalExam/skin/no-rash",
  SkinNoLesions = "forms/physicalExam/skin/no-lesions",
  SkinNoUnusualBruising = "forms/physicalExam/skin/no-unusual-bruising",
  SkinHairNormalTextureDistribution = "forms/physicalExam/skin/hair-normal-texture-distribution",
  SkinNailsNormalColorNoDeformities = "forms/physicalExam/skin/nails-normal-color-no-deformities",
  SkinNoTattoos = "forms/physicalExam/skin/no-tattoos",
  SkinNoScars = "forms/physicalExam/skin/no-scars",
  SkinNoPiercings = "forms/physicalExam/skin/no-piercings",
  SkinRashPresent = "forms/physicalExam/skin/rash-present",
  SkinLesionsPresent = "forms/physicalExam/skin/lesions-present",
  SkinBruisingPresent = "forms/physicalExam/skin/bruising-present",
  SkinTattoosPresent = "forms/physicalExam/skin/tattoos-present",
  SkinPiercingsPresent = "forms/physicalExam/skin/piercings-present",
  SkinScarsPresent = "forms/physicalExam/skin/scars-present",
  SkinHairLoss = "forms/physicalExam/skin/hair-loss",
  SkinHirsutism = "forms/physicalExam/skin/hirsutism",
  SkinNailsBrittle = "forms/physicalExam/skin/nails-brittle",
  PsychiatricNormalMoodAffect = "forms/physicalExam/psychiatric/normal-mood-affect",
  PsychiatricEpds0To6 = "forms/physicalExam/psychiatric/epds-0-6",
  PsychiatricPhq9FourOrLess = "forms/physicalExam/psychiatric/phq9-4-or-less",
  PsychiatricIntactRecentRemoteMemory = "forms/physicalExam/psychiatric/intact-recent-remote-memory",
  PsychiatricEpds7To13 = "forms/physicalExam/psychiatric/epds-7-13",
  PsychiatricEpds14To19 = "forms/physicalExam/psychiatric/epds-14-19",
  PsychiatricEpds19To30 = "forms/physicalExam/psychiatric/epds-19-30",
  PsychiatricPhq9FiveToNine = "forms/physicalExam/psychiatric/phq9-5-9",
  PsychiatricPhq9TenToFourteen = "forms/physicalExam/psychiatric/phq9-10-14",
  PsychiatricPhq9FifteenToNineteen = "forms/physicalExam/psychiatric/phq9-15-19",
  PsychiatricPhq9TwentyToTwentySeven = "forms/physicalExam/psychiatric/phq9-20-27",
  PsychiatricAnxious = "forms/physicalExam/psychiatric/anxious",
  PsychiatricDepressed = "forms/physicalExam/psychiatric/depressed",
  PsychiatricAgitated = "forms/physicalExam/psychiatric/agitated",
  PsychiatricHallucinations = "forms/physicalExam/psychiatric/hallucinations",
  PsychiatricParanoid = "forms/physicalExam/psychiatric/paranoid",
  PsychiatricPoorRecentMemory = "forms/physicalExam/psychiatric/poor-recent-memory",
  PsychiatricPoorRemoteMemory = "forms/physicalExam/psychiatric/poor-remote-memory",
  VulvaNoMasses = "forms/physicalExam/genitourinary/vulva-perineum/no-vulvar-masses",
  VulvaNoLesions = "forms/physicalExam/genitourinary/vulva-perineum/no-vulvar-lesions",
  VulvaNoAtrophy = "forms/physicalExam/genitourinary/vulva-perineum/no-vulvar-atrophy",
  VulvaNoArchitecturalDistortion = "forms/physicalExam/genitourinary/vulva-perineum/no-architectural-distortion",
  VulvaNoScars = "forms/physicalExam/genitourinary/vulva-perineum/no-scars",
  VulvaNoRashes = "forms/physicalExam/genitourinary/vulva-perineum/no-rashes",
  VulvaNoHematoma = "forms/physicalExam/genitourinary/vulva-perineum/no-hematoma",
  VulvaLacerationWellApproximated = "forms/physicalExam/genitourinary/vulva-perineum/laceration-episiotomy-well-approximated",
  VulvaMasses = "forms/physicalExam/genitourinary/vulva-perineum/vulvar-masses",
  VulvaLesions = "forms/physicalExam/genitourinary/vulva-perineum/vulvar-lesions",
  VulvaAtrophy = "forms/physicalExam/genitourinary/vulva-perineum/vulvar-atrophy",
  VulvaAgglutination = "forms/physicalExam/genitourinary/vulva-perineum/agglutination-of-tissue",
  VulvaRash = "forms/physicalExam/genitourinary/vulva-perineum/rash",
  VulvaThickenedSkin = "forms/physicalExam/genitourinary/vulva-perineum/thickened-skin",
  VulvaLacerationNotWellApproximated = "forms/physicalExam/genitourinary/vulva-perineum/laceration-episiotomy-not-well-approximated",
  PerineumWellApproximated = "forms/physicalExam/genitourinary/vulva-perineum/well-approximated",
  PerineumNotApproximated = "forms/physicalExam/genitourinary/vulva-perineum/not-approximated",
  PerineumRedness = "forms/physicalExam/genitourinary/vulva-perineum/redness",
  PerineumTenderness = "forms/physicalExam/genitourinary/vulva-perineum/tenderness",
  PerineumSuturesVisible = "forms/physicalExam/genitourinary/vulva-perineum/sutures-visible",
  PerineumPain = "forms/physicalExam/genitourinary/vulva-perineum/pain",
  PerineumNoInfection = "forms/physicalExam/genitourinary/vulva-perineum/no-infection",
  PerineumNoPain = "forms/physicalExam/genitourinary/vulva-perineum/no-pain",
  EpisiotomyWellApproximated = "forms/physicalExam/genitourinary/vulva-perineum/episiotomy-well-approximated",
  EpisiotomyNotApproximated = "forms/physicalExam/genitourinary/vulva-perineum/episiotomy-not-approximated",
  EpisiotomyRedness = "forms/physicalExam/genitourinary/vulva-perineum/episiotomy-redness",
  EpisiotomyTenderness = "forms/physicalExam/genitourinary/vulva-perineum/episiotomy-tenderness",
  EpisiotomySuturesVisible = "forms/physicalExam/genitourinary/vulva-perineum/episiotomy-sutures-visible",
  EpisiotomyPain = "forms/physicalExam/genitourinary/vulva-perineum/episiotomy-pain",
  EpisiotomyNoInfection = "forms/physicalExam/genitourinary/vulva-perineum/episiotomy-no-infection",
  EpisiotomyNoPain = "forms/physicalExam/genitourinary/vulva-perineum/episiotomy-no-pain",
  None = "forms/physicalExam/genitourinary/vulva-perineum/none",
  Labial = "forms/physicalExam/genitourinary/vulva-perineum/labial",
  Clitoral = "forms/physicalExam/genitourinary/vulva-perineum/clitoral",
  FirstDegree = "forms/physicalExam/genitourinary/vulva-perineum/1st",
  SecondDegree = "forms/physicalExam/genitourinary/vulva-perineum/2nd",
  ThirdDegree = "forms/physicalExam/genitourinary/vulva-perineum/3rd",
  FourthDegree = "forms/physicalExam/genitourinary/vulva-perineum/4th",
  Midline = "forms/physicalExam/genitourinary/vulva-perineum/midline",
  Mediolateral = "forms/physicalExam/genitourinary/vulva-perineum/mediolateral",
  NoVaricosities = "forms/physicalExam/genitourinary/vulva-perineum/no-varicosities",
  NoEdema = "forms/physicalExam/genitourinary/vulva-perineum/no-edema",
  Intact = "forms/physicalExam/genitourinary/vulva-perineum/intact",
  VaricositiesLSide = "forms/physicalExam/genitourinary/vulva-perineum/varicosities-l-side",
  VaricositiesRSide = "forms/physicalExam/genitourinary/vulva-perineum/varicosities-r-side",
  UnhealedLabialLaceration = "forms/physicalExam/genitourinary/vulva-perineum/unhealed-labial-laceration",
  UnhealedClitoralLaceration = "forms/physicalExam/genitourinary/vulva-perineum/unhealed-clitoral-laceration",
  LabiaMinoraRegressedOrAglutinated = "forms/physicalExam/genitourinary/vulva-perineum/labia-minora-regressed-or-aglutinated",
  RectumNoHemorrhoidsOrMasses = "forms/physicalExam/genitourinary/rectum/no-hemorrhoids-or-masses",
  RectumNormalSphincterTone = "forms/physicalExam/genitourinary/rectum/normal-sphincter-tone",
  RectumHemorrhoidsPresent = "forms/physicalExam/genitourinary/rectum/hemorrhoids-present",
  RectumMassesPresent = "forms/physicalExam/genitourinary/rectum/masses-present",
  RectumDecreasedSphincterTone = "forms/physicalExam/genitourinary/rectum/decreased-sphincter-tone",
  RectumIncreasedSphincterTone = "forms/physicalExam/genitourinary/rectum/increased-sphincter-tone",
  AnusNoHemorrhoids = "forms/physicalExam/genitourinary/rectum/no-hemorrhoids",
  AnusNoFissures = "forms/physicalExam/genitourinary/rectum/no-fissures",
  AnusNoLesions = "forms/physicalExam/genitourinary/rectum/no-lesions",
  AnusHemorrhoids = "forms/physicalExam/genitourinary/rectum/hemorrhoids",
  AnusFissure = "forms/physicalExam/genitourinary/rectum/fissure",
  AnusLesions = "forms/physicalExam/genitourinary/rectum/lesions",
  NoLesionsGeneral = "forms/physicalExam/genitourinary/vulva-perineum/no-lesions",
  LesionsGeneral = "forms/physicalExam/genitourinary/vulva-perineum/lesions",
  VaginaWithoutLesions = "forms/physicalExam/genitourinary/vagina/without-lesions",
  VaginaClearCreamyDischarge = "forms/physicalExam/genitourinary/vagina/clear-creamy-discharge",
  VaginaNoAtrophy = "forms/physicalExam/genitourinary/vagina/no-atrophy",
  VaginaNoPainWithInsertion = "forms/physicalExam/genitourinary/vagina/no-pain-with-insertion",
  VaginaIntactHymen = "forms/physicalExam/genitourinary/vagina/intact-hymen",
  VaginaVestibulitis = "forms/physicalExam/genitourinary/vagina/vestibulitis",
  VaginaAbnormalDischarge = "forms/physicalExam/genitourinary/vagina/abnormal-discharge",
  VaginaThickClumpyDischarge = "forms/physicalExam/genitourinary/vagina/thick-clumpy-discharge",
  VaginaYellowDischarge = "forms/physicalExam/genitourinary/vagina/yellow-discharge",
  VaginaGreenDischarge = "forms/physicalExam/genitourinary/vagina/green-discharge",
  VaginaBloodPresent = "forms/physicalExam/genitourinary/vagina/blood-present",
  VaginaLesions = "forms/physicalExam/genitourinary/vagina/lesions",
  VaginaAtrophy = "forms/physicalExam/genitourinary/vagina/atrophy",
  VaginaPainAtIntroitus = "forms/physicalExam/genitourinary/vagina/pain-at-introitus",
  VaginaPainWithDeepPalpation = "forms/physicalExam/genitourinary/vagina/pain-with-deep-palpation",
  CervixGrosslyNormal = "forms/physicalExam/genitourinary/cervix/grossly-normal-intact",
  CervixOsClosed = "forms/physicalExam/genitourinary/cervix/os-closed",
  CervixWithoutLesions = "forms/physicalExam/genitourinary/cervix/without-lesions",
  CervixWithoutDischarge = "forms/physicalExam/genitourinary/cervix/without-discharge",
  CervixNoMotionTenderness = "forms/physicalExam/genitourinary/cervix/no-cervical-motion-tenderness",
  CervixBloodFromOs = "forms/physicalExam/genitourinary/cervix/blood-from-os",
  CervixLesions = "forms/physicalExam/genitourinary/cervix/lesions",
  CervixFriable = "forms/physicalExam/genitourinary/cervix/friable",
  CervixRed = "forms/physicalExam/genitourinary/cervix/red",
  CervixDischarge = "forms/physicalExam/genitourinary/cervix/discharge",
  CervixMotionTenderness = "forms/physicalExam/genitourinary/cervix/motion-tenderness",
  CervixIUDStringsPresent = "forms/physicalExam/genitourinary/cervix/iud-strings-present",
  CervixIUDStringsNotPresent = "forms/physicalExam/genitourinary/cervix/iud-strings-not-present",
  CervixPolypsPresent = "forms/physicalExam/genitourinary/cervix/polyps-present",
  CervixNoTenderness = "forms/physicalExam/genitourinary/cervix/no-tenderness",
  CervixNoProlapse = "forms/physicalExam/genitourinary/cervix/no-prolapse",
  CervixTenderness = "forms/physicalExam/genitourinary/cervix/tenderness",
  CervixProlapse = "forms/physicalExam/genitourinary/cervix/prolapse",
  CervixProlapseToHymen = "forms/physicalExam/genitourinary/cervix/prolapse-to-hymen",
  CervixProlapsePastHymen = "forms/physicalExam/genitourinary/cervix/prolapse-past-hymen",
  UterusNotEnlarged = "forms/physicalExam/genitourinary/uterus-adnexa/not-enlarged",
  UterusNontender = "forms/physicalExam/genitourinary/uterus-adnexa/nontender",
  UterusNoMasses = "forms/physicalExam/genitourinary/uterus-adnexa/no-masses",
  UterusMobile = "forms/physicalExam/genitourinary/uterus-adnexa/mobile",
  UterusInverted = "forms/physicalExam/genitourinary/uterus-adnexa/inverted",
  UterusAnteflexed = "forms/physicalExam/genitourinary/uterus-adnexa/anteflexed",
  UterusAnteverted = "forms/physicalExam/genitourinary/uterus-adnexa/anteverted",
  UterusRetroflexed = "forms/physicalExam/genitourinary/uterus-adnexa/retroflexed",
  UterusRetroverted = "forms/physicalExam/genitourinary/uterus-adnexa/retroverted",
  UterusInvoluted = "forms/physicalExam/genitourinary/uterus-adnexa/involuted",
  UterusNotInvoluted = "forms/physicalExam/genitourinary/uterus-adnexa/not-involuted",
  UterusBoggy = "forms/physicalExam/genitourinary/uterus-adnexa/boggy",
  UterusNoTenderness = "forms/physicalExam/genitourinary/uterus-adnexa/no-tenderness",
  UterusTenderness = "forms/physicalExam/genitourinary/uterus-adnexa/tenderness",
  AdnexaNontender = "forms/physicalExam/genitourinary/uterus-adnexa/nontender-adnexa",
  AdnexaNotEnlarged = "forms/physicalExam/genitourinary/uterus-adnexa/not-enlarged-adnexa",
  AdnexaNoMasses = "forms/physicalExam/genitourinary/uterus-adnexa/no-adnexal-masses",
  AdnexaNoPain = "forms/physicalExam/genitourinary/uterus-adnexa/no-pain",
  AdnexaMass = "forms/physicalExam/genitourinary/uterus-adnexa/mass",
  AdnexaMasses = "forms/physicalExam/genitourinary/uterus-adnexa/masses",
  AdnexaPain = "forms/physicalExam/genitourinary/uterus-adnexa/pain",
  UterusNoLochia = "forms/physicalExam/genitourinary/uterus-adnexa/no-lochia",
  UterusGravid = "forms/physicalExam/genitourinary/uterus-adnexa/gravid",
  UterusAbsent = "forms/physicalExam/genitourinary/uterus-adnexa/absent",
  UterusEnlarged = "forms/physicalExam/genitourinary/uterus-adnexa/enlarged",
  UterusTender = "forms/physicalExam/genitourinary/uterus-adnexa/tender",
  UterusWithMasses = "forms/physicalExam/genitourinary/uterus-adnexa/with-masses",
  UterusPartiallyInverted = "forms/physicalExam/genitourinary/uterus-adnexa/partially-inverted",
  UterusFixedImmobile = "forms/physicalExam/genitourinary/uterus-adnexa/fixed-immobile",
  AdnexalTenderness = "forms/physicalExam/genitourinary/uterus-adnexa/adnexal-tenderness",
  RightAdnexalTenderness = "forms/physicalExam/genitourinary/uterus-adnexa/right-adnexal-tenderness",
  LeftAdnexalTenderness = "forms/physicalExam/genitourinary/uterus-adnexa/left-adnexal-tenderness",
  RightAdnexalMass = "forms/physicalExam/genitourinary/uterus-adnexa/right-adnexal-mass",
  LeftAdnexalMass = "forms/physicalExam/genitourinary/uterus-adnexa/left-adnexal-mass",
  LochiaRubra = "forms/physicalExam/genitourinary/uterus-adnexa/lochia-rubra",
  LochiaSerosa = "forms/physicalExam/genitourinary/uterus-adnexa/lochia-serosa",
  LochiaAlba = "forms/physicalExam/genitourinary/uterus-adnexa/lochia-alba",
  PelvicFloorNoCystocele = "forms/physicalExam/genitourinary/pelvic-floor/no-cystocele",
  PelvicFloorNoRectocele = "forms/physicalExam/genitourinary/pelvic-floor/no-rectocele",
  PelvicFloorNoProlapse = "forms/physicalExam/genitourinary/pelvic-floor/no-prolapse",
  PelvicFloorNoPainWithInsertion = "forms/physicalExam/genitourinary/pelvic-floor/no-pain-with-insertion",
  PelvicFloorNoPainWithPalpation = "forms/physicalExam/genitourinary/pelvic-floor/no-pain-with-palpation",
  PelvicFloorPainAtIntroitus = "forms/physicalExam/genitourinary/pelvic-floor/pain-at-introitus",
  PelvicFloorPainWithDeepPalpation = "forms/physicalExam/genitourinary/pelvic-floor/pain-with-deep-palpation",
  PelvicFloorCystocele = "forms/physicalExam/genitourinary/pelvic-floor/cystocele",
  PelvicFloorRectocele = "forms/physicalExam/genitourinary/pelvic-floor/rectocele",
  PelvicFloorProlapse = "forms/physicalExam/genitourinary/pelvic-floor/prolapse",
  PelvicFloorProlapseGrade1 = "forms/physicalExam/genitourinary/pelvic-floor/prolapse-grade-1",
  PelvicFloorProlapseGrade2 = "forms/physicalExam/genitourinary/pelvic-floor/prolapse-grade-2",
  PelvicFloorProlapseGrade3 = "forms/physicalExam/genitourinary/pelvic-floor/prolapse-grade-3",
  PelvicFloorProlapseGrade4 = "forms/physicalExam/genitourinary/pelvic-floor/prolapse-grade-4",
  PelvicFloorBladderPain = "forms/physicalExam/genitourinary/pelvic-floor/bladder-pain-with-internal-palpation",
  PelvicFloorDifficultySqueezing = "forms/physicalExam/genitourinary/pelvic-floor/difficulty-squeezing",
  PelvicFloorDifficultyPushing = "forms/physicalExam/genitourinary/pelvic-floor/difficulty-pushing",
  PelvicFloorNoPainAtIntroitus = "forms/physicalExam/genitourinary/pelvic-floor/no-pain-at-introitus",
  PelvicFloorNoBladderPain = "forms/physicalExam/genitourinary/pelvic-floor/no-bladder-pain-with-internal-palpation",
  PelvicFloorEasySqueezing = "forms/physicalExam/genitourinary/pelvic-floor/easy-squeezing-with-muscles",
  ClearToAuscultation = "forms/physicalExam/lungs/clear-to-auscultation",
  UnlaboredBreathing = "forms/physicalExam/lungs/unlabored-breathing",
  BowelSoundsAllQuadrants = "forms/physicalExam/abdomen/bowel-sounds-all-quadrants",
  NoTendernessRUQ = "forms/physicalExam/abdomen/no-tenderness-ruq",
  NoTendernessLUQ = "forms/physicalExam/abdomen/no-tenderness-luq",
  NoTendernessRLQ = "forms/physicalExam/abdomen/no-tenderness-rlq",
  NoTendernessLLQ = "forms/physicalExam/abdomen/no-tenderness-llq",
  AbdomenSoft = "forms/physicalExam/abdomen/abdomen-soft",
  NoOrganomegaly = "forms/physicalExam/abdomen/no-organomegaly",
  NoMassesAbdomen = "forms/physicalExam/abdomen/no-masses",
  NoHernia = "forms/physicalExam/abdomen/no-hernia",
  NoDiastasisRecti = "forms/physicalExam/abdomen/no-diastasis-recti",
  NoDistention = "forms/physicalExam/abdomen/no-distention",
  CSIncisionWellApproximated = "forms/physicalExam/abdomen/cs-incision-well-approximated",
  DiminishedBowelSounds = "forms/physicalExam/abdomen/diminished-bowel-sounds",
  RUQPain = "forms/physicalExam/abdomen/ruq-pain",
  LUQPain = "forms/physicalExam/abdomen/luq-pain",
  LLQPain = "forms/physicalExam/abdomen/llq-pain",
  RLQPain = "forms/physicalExam/abdomen/rlq-pain",
  AbdominalTenderness = "forms/physicalExam/abdomen/abdominal-tenderness",
  Hepatomegaly = "forms/physicalExam/abdomen/hepatomegaly",
  Splenomegaly = "forms/physicalExam/abdomen/splenomegaly",
  RigidAbdomen = "forms/physicalExam/abdomen/rigid-abdomen",
  Guarding = "forms/physicalExam/abdomen/guarding",
  UmbilicalHernia = "forms/physicalExam/abdomen/umbilical-hernia",
  InguinalHernia = "forms/physicalExam/abdomen/inguinal-hernia",
  CSIncisionNotApproximated = "forms/physicalExam/abdomen/cs-incision-not-approximated",
  CSIncisionDischarge = "forms/physicalExam/abdomen/cs-incision-discharge",
  CSIncisionOdor = "forms/physicalExam/abdomen/cs-incision-odor",
  CSIncisionPain = "forms/physicalExam/abdomen/cs-incision-pain",
  NoCVA = "forms/physicalExam/back/no-cva-tenderness",
  SpineNormal = "forms/physicalExam/back/spine-normal",
  RightCVATenderness = "forms/physicalExam/back/right-cva-tenderness",
  LeftCVATenderness = "forms/physicalExam/back/left-cva-tenderness",
  Scoliosis = "forms/physicalExam/back/scoliosis",
  Kyphosis = "forms/physicalExam/back/kyphosis",
  Lordosis = "forms/physicalExam/back/lordosis",
  NormalGaitStation = "forms/physicalExam/musculoskeletal/normal-gait-station",
  NoAsymmetry = "forms/physicalExam/musculoskeletal/no-asymmetry",
  NoDefects = "forms/physicalExam/musculoskeletal/no-defects",
  NoTendernessMusculoskeletal = "forms/physicalExam/musculoskeletal/no-tenderness",
  NoMassesMusculoskeletal = "forms/physicalExam/musculoskeletal/no-masses",
  NoEffusions = "forms/physicalExam/musculoskeletal/no-effusions",
  NoDecreasedRangeOfMotion = "forms/physicalExam/musculoskeletal/no-decreased-range-of-motion",
  NoInstability = "forms/physicalExam/musculoskeletal/no-instability",
  NoAbnormalStrengthTone = "forms/physicalExam/musculoskeletal/no-abnormal-strength-tone",
  PainOfPalpation = "forms/physicalExam/musculoskeletal/pain-of-palpation",
  PainWithMovement = "forms/physicalExam/musculoskeletal/pain-with-movement",
  Asymmetry = "forms/physicalExam/musculoskeletal/asymmetry",
  AbnormalGait = "forms/physicalExam/musculoskeletal/abnormal-gait",
  Limp = "forms/physicalExam/musculoskeletal/limp",
  DecreasedRangeOfMotion = "forms/physicalExam/musculoskeletal/decreased-range-of-motion",
  UseOfWalkingAids = "forms/physicalExam/musculoskeletal/use-of-walking-aids",
  MuscularAtrophy = "forms/physicalExam/musculoskeletal/muscular-atrophy",
  Defect = "forms/physicalExam/musculoskeletal/defect",
  Amputation = "forms/physicalExam/musculoskeletal/amputation",
}

export enum GynecologicalPhysicalExamCodes {
  BowelSoundsAll4Quadrants = "forms/physicalExam/gynecological/abdomen/bowel-sounds-all-quadrants",
  NoTendernessRUQ = "forms/physicalExam/gynecological/abdomen/no-tenderness-ruq",
  NoTendernessLUQ = "forms/physicalExam/gynecological/abdomen/no-tenderness-luq",
  NoTendernessRLQ = "forms/physicalExam/gynecological/abdomen/no-tenderness-rlq",
  NoTendernessLLQ = "forms/physicalExam/gynecological/abdomen/no-tenderness-llq",
  AbdomenSoft = "forms/physicalExam/gynecological/abdomen/abdomen-soft",
  NoOrganomegaly = "forms/physicalExam/gynecological/abdomen/no-organomegaly",
  NoMasses = "forms/physicalExam/gynecological/abdomen/no-masses",
  NoHernia = "forms/physicalExam/gynecological/abdomen/no-hernia",
  NoDiastasisRecti = "forms/physicalExam/gynecological/abdomen/no-diastasis-recti",
  NoDistention = "forms/physicalExam/gynecological/abdomen/no-distention",
  CSIncisionWellApproximated = "forms/physicalExam/gynecological/abdomen/cs-incision-well-approximated",
  DiminishedBowelSounds = "forms/physicalExam/gynecological/abdomen/diminished-bowel-sounds",
  RUQPain = "forms/physicalExam/gynecological/abdomen/ruq-pain",
  LUQPain = "forms/physicalExam/gynecological/abdomen/luq-pain",
  LLQPain = "forms/physicalExam/gynecological/abdomen/llq-pain",
  RLQPain = "forms/physicalExam/gynecological/abdomen/rlq-pain",
  AbdominalTenderness = "forms/physicalExam/gynecological/abdomen/abdominal-tenderness",
  Hepatomegaly = "forms/physicalExam/gynecological/abdomen/hepatomegaly",
  Splenomegaly = "forms/physicalExam/gynecological/abdomen/splenomegaly",
  RigidAbdomen = "forms/physicalExam/gynecological/abdomen/rigid-abdomen",
  MassesPresent = "forms/physicalExam/gynecological/abdomen/masses-present",
  Guarding = "forms/physicalExam/gynecological/abdomen/guarding",
  UmbilicalHernia = "forms/physicalExam/gynecological/abdomen/umbilical-hernia",
  InguinalHernia = "forms/physicalExam/gynecological/abdomen/inguinal-hernia",
  DiastasisRecti1cm = "forms/physicalExam/gynecological/abdomen/diastasis-recti-1cm",
  DiastasisRecti2cm = "forms/physicalExam/gynecological/abdomen/diastasis-recti-2cm",
  DiastasisRecti3cm = "forms/physicalExam/gynecological/abdomen/diastasis-recti-3cm",
  DiastasisRecti4PlusCm = "forms/physicalExam/gynecological/abdomen/diastasis-recti-4plus-cm",
  CSIncisionNotApproximated = "forms/physicalExam/gynecological/abdomen/cs-incision-not-approximated",
  CSIncisionDischarge = "forms/physicalExam/gynecological/abdomen/cs-incision-discharge",
  CSIncisionOdor = "forms/physicalExam/gynecological/abdomen/cs-incision-odor",
  CSIncisionPain = "forms/physicalExam/gynecological/abdomen/cs-incision-pain",
  ThyroidEnlarged = "forms/physicalExam/gynecological/neck/thyroid-enlarged",
  ThyroidNodules = "forms/physicalExam/gynecological/neck/thyroid-nodules",
  ThyroidTenderness = "forms/physicalExam/gynecological/neck/thyroid-tenderness",
  PainWithMotion = "forms/physicalExam/gynecological/neck/pain-with-motion",
  NeckTenderness = "forms/physicalExam/gynecological/neck/neck-tenderness",
  EnlargedLymphNodes = "forms/physicalExam/gynecological/neck/enlarged-lymph-nodes",
  Rigid = "forms/physicalExam/gynecological/neck/rigid",
  DeviatedTrachea = "forms/physicalExam/gynecological/neck/deviated-trachea",
  NeckMassesPresent = "forms/physicalExam/gynecological/neck/masses-present",
  ThyroidNonEnlarged = "forms/physicalExam/gynecological/neck/thyroid-non-enlarged",
  ThyroidNonTender = "forms/physicalExam/gynecological/neck/thyroid-non-tender",
  ThyroidWithoutMasses = "forms/physicalExam/gynecological/neck/thyroid-without-masses",
  Supple = "forms/physicalExam/gynecological/neck/supple",
  TracheaMidline = "forms/physicalExam/gynecological/neck/trachea-midline",
  NoLesionsBruitsOrAdenopathy = "forms/physicalExam/gynecological/neck/no-lesions-bruits-or-adenopathy",
  // Anus codes
  NoHemorrhoids = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/anus/no-hemorrhoids",
  NoFissures = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/anus/no-fissures",
  NoLesions = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/anus/no-lesions",
  Hemorrhoids = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/anus/hemorrhoids",
  Fissure = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/anus/fissure",
  Lesions = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/anus/lesions",
  // Perineum & External Genitalia codes
  NoLesionsGeneral = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/no-lesions",
  NoVaricosities = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/no-varicosities",
  NoEdema = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/no-edema",
  LesionsGeneral = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/lesions",
  VaricositiesLSide = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/varicosities-l-side",
  VaricositiesRSide = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/varicosities-r-side",
  UnhealedLabialLaceration = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/unhealed-labial-laceration",
  // Cervix codes
  CervixNoTenderness = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/cervix/no-tenderness",
  CervixNoProlapse = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/cervix/no-prolapse",
  CervixTenderness = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/cervix/tenderness",
  CervixProlapse = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/cervix/prolapse",
  CervixProlapseToHymen = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/cervix/prolapse-to-hymen",
  CervixProlapsePastHymen = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/cervix/prolapse-past-hymen",
  Intact = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/intact",
  UnhealedClitoralLaceration = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/unhealed-clitoral-laceration",
  LabiaMinoraRegressedOrAglutinated = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/labia-minora-regressed-or-aglutinated",
  VaginaNoDischarge = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/vagina/no-discharge",
  VaginaNoProlapse = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/vagina/no-prolapse",
  VaginaNoGranulationTissue = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/vagina/no-granulation-tissue",
  VaginaDischarge = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/vagina/discharge",
  VaginaCystocele = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/vagina/cystocele",
  VaginaRectocele = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/vagina/rectocele",
  VaginaGranulationTissue = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/vagina/granulation-tissue",
  UterusNoTenderness = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/uterus/no-tenderness",
  UterusInvoluted = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/uterus/involuted",
  UterusTenderness = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/uterus/tenderness",
  UterusNotInvoluted = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/uterus/not-involuted",
  UterusBoggy = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/uterus/boggy",
  AdnexaNoPain = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/adnexa/no-pain",
  AdnexaNoMasses = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/adnexa/no-masses",
  AdnexaMass = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/adnexa/mass",
  AdnexaMasses = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/adnexa/masses",
  AdnexaPain = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/adnexa/pain",
  PerineumWellApproximated = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/perineum/well-approximated",
  PerineumNoInfection = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/perineum/no-infection",
  PerineumNoPain = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/perineum/no-pain",
  PerineumNotApproximated = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/perineum/not-approximated",
  PerineumRedness = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/perineum/redness",
  PerineumTenderness = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/perineum/tenderness",
  PerineumSuturesVisible = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/perineum/sutures-visible",
  PerineumPain = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/perineum/pain",
  PerineumLacerationNone = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/none",
  PerineumLacerationLabial = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/labial",
  PerineumLacerationClitoral = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/clitoral",
  PerineumLacerationFirst = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/1st",
  PerineumLacerationSecond = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/2nd",
  PerineumLacerationThird = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/3rd",
  PerineumLacerationFourth = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/4th",
  EpisiotomyTypeMidline = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/midline",
  EpisiotomyTypeMediolateral = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/mediolateral",
  EpisiotomyWellApproximated = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/episiotomy/well-approximated",
  EpisiotomyNoInfection = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/episiotomy/no-infection",
  EpisiotomyNoPain = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/episiotomy/no-pain",
  EpisiotomyNotApproximated = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/episiotomy/not-approximated",
  EpisiotomyRedness = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/episiotomy/redness",
  EpisiotomyTenderness = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/episiotomy/tenderness",
  EpisiotomySuturesVisible = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/episiotomy/sutures-visible",
  EpisiotomyPain = "forms/physicalExam/gynecological/perineumAndExternalGenitalia/episiotomy/pain",
}

export enum PostpartumPhysicalExamCodes {
  BowelSoundsAll4Quadrants = "forms/physicalExam/postpartum/abdomen/bowel-sounds-all-quadrants",
  NoTendernessRUQ = "forms/physicalExam/postpartum/abdomen/no-tenderness-ruq",
  NoTendernessLUQ = "forms/physicalExam/postpartum/abdomen/no-tenderness-luq",
  NoTendernessRLQ = "forms/physicalExam/postpartum/abdomen/no-tenderness-rlq",
  NoTendernessLLQ = "forms/physicalExam/postpartum/abdomen/no-tenderness-llq",
  AbdomenSoft = "forms/physicalExam/postpartum/abdomen/abdomen-soft",
  NoOrganomegaly = "forms/physicalExam/postpartum/abdomen/no-organomegaly",
  NoMasses = "forms/physicalExam/postpartum/abdomen/no-masses",
  NoHernia = "forms/physicalExam/postpartum/abdomen/no-hernia",
  NoDiastasisRecti = "forms/physicalExam/postpartum/abdomen/no-diastasis-recti",
  NoDistention = "forms/physicalExam/postpartum/abdomen/no-distention",
  CSIncisionWellApproximated = "forms/physicalExam/postpartum/abdomen/cs-incision-well-approximated",
  DiminishedBowelSounds = "forms/physicalExam/postpartum/abdomen/diminished-bowel-sounds",
  RUQPain = "forms/physicalExam/postpartum/abdomen/ruq-pain",
  LUQPain = "forms/physicalExam/postpartum/abdomen/luq-pain",
  LLQPain = "forms/physicalExam/postpartum/abdomen/llq-pain",
  RLQPain = "forms/physicalExam/postpartum/abdomen/rlq-pain",
  AbdominalTenderness = "forms/physicalExam/postpartum/abdomen/abdominal-tenderness",
  Hepatomegaly = "forms/physicalExam/postpartum/abdomen/hepatomegaly",
  Splenomegaly = "forms/physicalExam/postpartum/abdomen/splenomegaly",
  RigidAbdomen = "forms/physicalExam/postpartum/abdomen/rigid-abdomen",
  MassesPresent = "forms/physicalExam/postpartum/abdomen/masses-present",
  Guarding = "forms/physicalExam/postpartum/abdomen/guarding",
  UmbilicalHernia = "forms/physicalExam/postpartum/abdomen/umbilical-hernia",
  InguinalHernia = "forms/physicalExam/postpartum/abdomen/inguinal-hernia",
  DiastasisRecti1cm = "forms/physicalExam/postpartum/abdomen/diastasis-recti-1cm",
  DiastasisRecti2cm = "forms/physicalExam/postpartum/abdomen/diastasis-recti-2cm",
  DiastasisRecti3cm = "forms/physicalExam/postpartum/abdomen/diastasis-recti-3cm",
  DiastasisRecti4PlusCm = "forms/physicalExam/postpartum/abdomen/diastasis-recti-4plus-cm",
  CSIncisionNotApproximated = "forms/physicalExam/postpartum/abdomen/cs-incision-not-approximated",
  CSIncisionDischarge = "forms/physicalExam/postpartum/abdomen/cs-incision-discharge",
  CSIncisionOdor = "forms/physicalExam/postpartum/abdomen/cs-incision-odor",
  CSIncisionPain = "forms/physicalExam/postpartum/abdomen/cs-incision-pain",
  ThyroidEnlarged = "forms/physicalExam/postpartum/neck/thyroid-enlarged",
  ThyroidNodules = "forms/physicalExam/postpartum/neck/thyroid-nodules",
  ThyroidTenderness = "forms/physicalExam/postpartum/neck/thyroid-tenderness",
  PainWithMotion = "forms/physicalExam/postpartum/neck/pain-with-motion",
  NeckTenderness = "forms/physicalExam/postpartum/neck/neck-tenderness",
  EnlargedLymphNodes = "forms/physicalExam/postpartum/neck/enlarged-lymph-nodes",
  Rigid = "forms/physicalExam/postpartum/neck/rigid",
  DeviatedTrachea = "forms/physicalExam/postpartum/neck/deviated-trachea",
  NeckMassesPresent = "forms/physicalExam/postpartum/neck/masses-present",
  ThyroidNonEnlarged = "forms/physicalExam/postpartum/neck/thyroid-non-enlarged",
  ThyroidNonTender = "forms/physicalExam/postpartum/neck/thyroid-non-tender",
  ThyroidWithoutMasses = "forms/physicalExam/postpartum/neck/thyroid-without-masses",
  Supple = "forms/physicalExam/postpartum/neck/supple",
  TracheaMidline = "forms/physicalExam/postpartum/neck/trachea-midline",
  NoLesionsBruitsOrAdenopathy = "forms/physicalExam/postpartum/neck/no-lesions-bruits-or-adenopathy",
}

export enum PerineumAndExternalGenitaliaPhysicalExamCodes {
  AdnexaNoPain = "forms/physicalExam/perineumAndExternalGenitalia/adnexa/no-pain",
  AdnexaNoMasses = "forms/physicalExam/perineumAndExternalGenitalia/adnexa/no-masses",
  AdnexaMass = "forms/physicalExam/perineumAndExternalGenitalia/adnexa/mass",
  AdnexaMasses = "forms/physicalExam/perineumAndExternalGenitalia/adnexa/masses",
  AdnexaPain = "forms/physicalExam/perineumAndExternalGenitalia/adnexa/pain",

  VaginaNoDischarge = "forms/physicalExam/perineumAndExternalGenitalia/vagina/no-discharge",
  VaginaNoProlapse = "forms/physicalExam/perineumAndExternalGenitalia/vagina/no-prolapse",
  VaginaNoGranulationTissue = "forms/physicalExam/perineumAndExternalGenitalia/vagina/no-granulation-tissue",
  VaginaDischarge = "forms/physicalExam/perineumAndExternalGenitalia/vagina/discharge",
  VaginaCystocele = "forms/physicalExam/perineumAndExternalGenitalia/vagina/cystocele",
  VaginaRectocele = "forms/physicalExam/perineumAndExternalGenitalia/vagina/rectocele",
  VaginaGranulationTissue = "forms/physicalExam/perineumAndExternalGenitalia/vagina/granulation-tissue",

  UterusNoTenderness = "forms/physicalExam/perineumAndExternalGenitalia/uterus/no-tenderness",
  UterusInvoluted = "forms/physicalExam/perineumAndExternalGenitalia/uterus/involuted",
  UterusTenderness = "forms/physicalExam/perineumAndExternalGenitalia/uterus/tenderness",
  UterusNotInvoluted = "forms/physicalExam/perineumAndExternalGenitalia/uterus/not-involuted",
  UterusBoggy = "forms/physicalExam/perineumAndExternalGenitalia/uterus/boggy",

  CervixNoTenderness = "forms/physicalExam/perineumAndExternalGenitalia/cervix/no-tenderness",
  CervixNoProlapse = "forms/physicalExam/perineumAndExternalGenitalia/cervix/no-prolapse",
  CervixTenderness = "forms/physicalExam/perineumAndExternalGenitalia/cervix/tenderness",
  CervixProlapse = "forms/physicalExam/perineumAndExternalGenitalia/cervix/prolapse",
  CervixProlapseToHymen = "forms/physicalExam/perineumAndExternalGenitalia/cervix/prolapse-to-hymen",
  CervixProlapsePastHymen = "forms/physicalExam/perineumAndExternalGenitalia/cervix/prolapse-past-hymen",

  AnusHemorrhoids = "forms/physicalExam/perineumAndExternalGenitalia/anus/hemorrhoids",
  AnusFissure = "forms/physicalExam/perineumAndExternalGenitalia/anus/fissure",
  AnusLesions = "forms/physicalExam/perineumAndExternalGenitalia/anus/lesions",
  AnusNoHemorrhoids = "forms/physicalExam/perineumAndExternalGenitalia/anus/no-hemorrhoids",
  AnusNoFissures = "forms/physicalExam/perineumAndExternalGenitalia/anus/no-fissures",
  AnusNoLesions = "forms/physicalExam/perineumAndExternalGenitalia/anus/no-lesions",

  Midline = "forms/physicalExam/perineumAndExternalGenitalia/midline",
  Mediolateral = "forms/physicalExam/perineumAndExternalGenitalia/mediolateral",
  EpisiotomyWellApproximated = "forms/physicalExam/perineumAndExternalGenitalia/episiotomy/well-approximated",
  EpisiotomyNoInfection = "forms/physicalExam/perineumAndExternalGenitalia/episiotomy/no-infection",
  EpisiotomyNoPain = "forms/physicalExam/perineumAndExternalGenitalia/episiotomy/no-pain",
  EpisiotomyNotApproximated = "forms/physicalExam/perineumAndExternalGenitalia/episiotomy/not-approximated",
  EpisiotomyRedness = "forms/physicalExam/perineumAndExternalGenitalia/episiotomy/redness",
  EpisiotomyTenderness = "forms/physicalExam/perineumAndExternalGenitalia/episiotomy/tenderness",
  EpisiotomySuturesVisible = "forms/physicalExam/perineumAndExternalGenitalia/episiotomy/sutures-visible",
  EpisiotomyPain = "forms/physicalExam/perineumAndExternalGenitalia/episiotomy/pain",

  PerineumWellApproximated = "forms/physicalExam/perineumAndExternalGenitalia/perineum/well-approximated",
  PerineumNoInfection = "forms/physicalExam/perineumAndExternalGenitalia/perineum/no-infection",
  PerineumNoPain = "forms/physicalExam/perineumAndExternalGenitalia/perineum/no-pain",
  PerineumNotApproximated = "forms/physicalExam/perineumAndExternalGenitalia/perineum/not-approximated",
  PerineumRedness = "forms/physicalExam/perineumAndExternalGenitalia/perineum/redness",
  PerineumTenderness = "forms/physicalExam/perineumAndExternalGenitalia/perineum/tenderness",
  PerineumSuturesVisible = "forms/physicalExam/perineumAndExternalGenitalia/perineum/sutures-visible",
  PerineumPain = "forms/physicalExam/perineumAndExternalGenitalia/perineum/pain",

  NoLesions = "forms/physicalExam/perineumAndExternalGenitalia/no-lesions",
  NoVaricosities = "forms/physicalExam/perineumAndExternalGenitalia/no-varicosities",
  NoEdema = "forms/physicalExam/perineumAndExternalGenitalia/no-edema",
  Intact = "forms/physicalExam/perineumAndExternalGenitalia/intact",
  Lesions = "forms/physicalExam/perineumAndExternalGenitalia/lesions",
  VaricositiesLSide = "forms/physicalExam/perineumAndExternalGenitalia/varicosities-l-side",
  VaricositiesRSide = "forms/physicalExam/perineumAndExternalGenitalia/varicosities-r-side",
  UnhealedLabialLaceration = "forms/physicalExam/perineumAndExternalGenitalia/unhealed-labial-laceration",
  UnhealedClitoralLaceration = "forms/physicalExam/perineumAndExternalGenitalia/unhealed-clitoral-laceration",
  LabiaMinoraRegressedOrAglutinated = "forms/physicalExam/perineumAndExternalGenitalia/labia-minora-regressed-or-aglutinated",
  PerineumLacerationNone = "forms/physicalExam/perineumAndExternalGenitalia/none",
  PerineumLacerationLabial = "forms/physicalExam/perineumAndExternalGenitalia/labial",
  PerineumLacerationClitoral = "forms/physicalExam/perineumAndExternalGenitalia/clitoral",
  PerineumLacerationFirst = "forms/physicalExam/perineumAndExternalGenitalia/1st",
  PerineumLacerationSecond = "forms/physicalExam/perineumAndExternalGenitalia/2nd",
  PerineumLacerationThird = "forms/physicalExam/perineumAndExternalGenitalia/3rd",
  PerineumLacerationFourth = "forms/physicalExam/perineumAndExternalGenitalia/4th",
}

export const PhysicalExamDisplays = {
  [PostpartumPhysicalExamCodes.BowelSoundsAll4Quadrants]: "Bowel sounds in all 4 quadrants",
  [PostpartumPhysicalExamCodes.NoTendernessRUQ]: "No tenderness in RUQ",
  [PostpartumPhysicalExamCodes.NoTendernessLUQ]: "No tenderness in LUQ",
  [PostpartumPhysicalExamCodes.NoTendernessRLQ]: "No tenderness in RLQ",
  [PostpartumPhysicalExamCodes.NoTendernessLLQ]: "No tenderness in LLQ",
  [PostpartumPhysicalExamCodes.AbdomenSoft]: "Abdomen soft",
  [PostpartumPhysicalExamCodes.NoOrganomegaly]: "No organomegaly",
  [PostpartumPhysicalExamCodes.NoMasses]: "No masses",
  [PostpartumPhysicalExamCodes.NoHernia]: "No hernia",
  [PostpartumPhysicalExamCodes.NoDiastasisRecti]: "No diastasis recti",
  [PostpartumPhysicalExamCodes.NoDistention]: "No distention",
  [PostpartumPhysicalExamCodes.CSIncisionWellApproximated]: "C/S incision well approximated",
  [PostpartumPhysicalExamCodes.DiminishedBowelSounds]: "Diminished bowel sounds",
  [PostpartumPhysicalExamCodes.RUQPain]: "RUQ pain",
  [PostpartumPhysicalExamCodes.LUQPain]: "LUQ pain",
  [PostpartumPhysicalExamCodes.LLQPain]: "LLQ pain",
  [PostpartumPhysicalExamCodes.RLQPain]: "RLQ pain",
  [PostpartumPhysicalExamCodes.AbdominalTenderness]: "Abdominal tenderness",
  [PostpartumPhysicalExamCodes.Hepatomegaly]: "Hepatomegaly",
  [PostpartumPhysicalExamCodes.Splenomegaly]: "Splenomegaly",
  [PostpartumPhysicalExamCodes.RigidAbdomen]: "Rigid abdomen",
  [PostpartumPhysicalExamCodes.MassesPresent]: "Masses present",
  [PostpartumPhysicalExamCodes.Guarding]: "Guarding",
  [PostpartumPhysicalExamCodes.UmbilicalHernia]: "Umbilical hernia",
  [PostpartumPhysicalExamCodes.InguinalHernia]: "Inguinal hernia",
  [PostpartumPhysicalExamCodes.DiastasisRecti1cm]: "Diastasis recti 1cm",
  [PostpartumPhysicalExamCodes.DiastasisRecti2cm]: "Diastasis recti 2cm",
  [PostpartumPhysicalExamCodes.DiastasisRecti3cm]: "Diastasis recti 3cm",
  [PostpartumPhysicalExamCodes.DiastasisRecti4PlusCm]: "Diastasis recti 4+cm",
  [PostpartumPhysicalExamCodes.CSIncisionNotApproximated]: "C/S incision not approximated",
  [PostpartumPhysicalExamCodes.CSIncisionDischarge]: "C/S incision with discharge",
  [PostpartumPhysicalExamCodes.CSIncisionOdor]: "C/S incision with odor",
  [PostpartumPhysicalExamCodes.CSIncisionPain]: "C/S incision pain",
  [PostpartumPhysicalExamCodes.ThyroidEnlarged]: "Thyroid enlarged",
  [PostpartumPhysicalExamCodes.ThyroidNodules]: "Thyroid nodules",
  [PostpartumPhysicalExamCodes.ThyroidTenderness]: "Thyroid tenderness",
  [PostpartumPhysicalExamCodes.PainWithMotion]: "Pain with motion",
  [PostpartumPhysicalExamCodes.NeckTenderness]: "Neck tenderness",
  [PostpartumPhysicalExamCodes.EnlargedLymphNodes]: "Enlarged lymph nodes",
  [PostpartumPhysicalExamCodes.Rigid]: "Rigid",
  [PostpartumPhysicalExamCodes.DeviatedTrachea]: "Deviated trachea",
  [PostpartumPhysicalExamCodes.NeckMassesPresent]: "Mass(es) present",
  [PostpartumPhysicalExamCodes.ThyroidNonEnlarged]: "Thyroid non-enlarged",
  [PostpartumPhysicalExamCodes.ThyroidNonTender]: "Thyroid non-tender",
  [PostpartumPhysicalExamCodes.ThyroidWithoutMasses]: "Thyroid without masses",
  [PostpartumPhysicalExamCodes.Supple]: "Supple",
  [PostpartumPhysicalExamCodes.TracheaMidline]: "Trachea midline",
  [PostpartumPhysicalExamCodes.NoLesionsBruitsOrAdenopathy]: "No lesions, bruits, or adenopathy",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.AdnexaMasses]: "Masses",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.AdnexaMass]: "Mass",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.AdnexaPain]: "Pain",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.AdnexaNoPain]: "No pain",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.AdnexaNoMasses]: "No masses",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.VaginaNoDischarge]: "No discharge",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.VaginaNoProlapse]: "No prolapse",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.VaginaNoGranulationTissue]: "Granulation tissue",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.VaginaDischarge]: "Discharge",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.VaginaCystocele]: "Cystocele",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.VaginaRectocele]: "Rectocele",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.VaginaGranulationTissue]: "Granulation tissue",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.UterusNoTenderness]: "Tenderness",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.UterusInvoluted]: "Involuted",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.UterusTenderness]: "Tenderness",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.UterusNotInvoluted]: "Not involuted",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.UterusBoggy]: "Boggy",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.CervixNoTenderness]: "No tenderness",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.CervixNoProlapse]: "No prolapse",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.CervixTenderness]: "Tenderness",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.CervixProlapse]: "Prolapse",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.CervixProlapseToHymen]: "Cervix prolapse to hymen",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.CervixProlapsePastHymen]: "Prolapse past hymen",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.AnusHemorrhoids]: "Hemorrhoids",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.AnusFissure]: "Fissure",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.AnusLesions]: "Lesions",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.AnusNoHemorrhoids]: "No hemorrhoids",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.AnusNoFissures]: "No fissures",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.AnusNoLesions]: "No lesions",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.Midline]: "Midline",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.Mediolateral]: "Mediolateral",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.EpisiotomyWellApproximated]: "Well approximated",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.EpisiotomyNoInfection]: "No infection",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.EpisiotomyNoPain]: "No pain",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.EpisiotomyNotApproximated]: "Not approximated",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.EpisiotomyRedness]: "Redness",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.EpisiotomyTenderness]: "Tenderness",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.EpisiotomySuturesVisible]: "Sutures visible",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.EpisiotomyPain]: "Pain",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.PerineumWellApproximated]: "Well approximated",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.PerineumNoInfection]: "No infection",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.PerineumNoPain]: "No pain",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.PerineumNotApproximated]: "Not approximated",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.PerineumRedness]: "Redness",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.PerineumTenderness]: "Tenderness",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.PerineumSuturesVisible]: "Sutures visible",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.PerineumPain]: "Pain",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.NoLesions]: "No lesions",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.NoVaricosities]: "No varicosities",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.NoEdema]: "No edema",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.Intact]: "Intact",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.Lesions]: "Lesions",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.VaricositiesLSide]: "Varicosities L side",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.VaricositiesRSide]: "Varicosities R side",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.UnhealedLabialLaceration]:
    "Unhealed labial laceration",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.UnhealedClitoralLaceration]:
    "Unhealed clitoral laceration",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.LabiaMinoraRegressedOrAglutinated]:
    "Labia minora regressed or aglutinated",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.PerineumLacerationNone]: "None",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.PerineumLacerationLabial]: "Labial",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.PerineumLacerationClitoral]: "Clitoral",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.PerineumLacerationFirst]: "First",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.PerineumLacerationSecond]: "Second",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.PerineumLacerationThird]: "Third",
  [PerineumAndExternalGenitaliaPhysicalExamCodes.PerineumLacerationFourth]: "Fourth",
  [GynecologicalPhysicalExamCodes.ThyroidEnlarged]: "Thyroid enlarged",
  [GynecologicalPhysicalExamCodes.ThyroidNodules]: "Thyroid nodules",
  [GynecologicalPhysicalExamCodes.ThyroidTenderness]: "Thyroid tenderness",
  [GynecologicalPhysicalExamCodes.PainWithMotion]: "Pain with motion",
  [GynecologicalPhysicalExamCodes.NeckTenderness]: "Neck tenderness",
  [GynecologicalPhysicalExamCodes.EnlargedLymphNodes]: "Enlarged lymph nodes",
  [GynecologicalPhysicalExamCodes.Rigid]: "Rigid",
  [GynecologicalPhysicalExamCodes.DeviatedTrachea]: "Deviated trachea",
  [GynecologicalPhysicalExamCodes.NeckMassesPresent]: "Mass(es) present",
  [GynecologicalPhysicalExamCodes.ThyroidNonEnlarged]: "Thyroid non-enlarged",
  [GynecologicalPhysicalExamCodes.ThyroidNonTender]: "Thyroid non-tender",
  [GynecologicalPhysicalExamCodes.ThyroidWithoutMasses]: "Thyroid without masses",
  [GynecologicalPhysicalExamCodes.Supple]: "Supple",
  [GynecologicalPhysicalExamCodes.TracheaMidline]: "Trachea midline",
  [GynecologicalPhysicalExamCodes.NoLesionsBruitsOrAdenopathy]: "No lesions, bruits, or adenopathy",
  [GynecologicalPhysicalExamCodes.BowelSoundsAll4Quadrants]: "Bowel sounds in all 4 quadrants",
  [GynecologicalPhysicalExamCodes.NoTendernessRUQ]: "No tenderness in RUQ",
  [GynecologicalPhysicalExamCodes.NoTendernessLUQ]: "No tenderness in LUQ",
  [GynecologicalPhysicalExamCodes.NoTendernessRLQ]: "No tenderness in RLQ",
  [GynecologicalPhysicalExamCodes.NoTendernessLLQ]: "No tenderness in LLQ",
  [GynecologicalPhysicalExamCodes.AbdomenSoft]: "Abdomen soft",
  [GynecologicalPhysicalExamCodes.NoOrganomegaly]: "No organomegaly",
  [GynecologicalPhysicalExamCodes.NoMasses]: "No masses",
  [GynecologicalPhysicalExamCodes.NoHernia]: "No hernia",
  [GynecologicalPhysicalExamCodes.NoDiastasisRecti]: "No diastasis recti",
  [GynecologicalPhysicalExamCodes.NoDistention]: "No distention",
  [GynecologicalPhysicalExamCodes.CSIncisionWellApproximated]: "C/S incision well approximated",
  [GynecologicalPhysicalExamCodes.DiminishedBowelSounds]: "Diminished bowel sounds",
  [GynecologicalPhysicalExamCodes.RUQPain]: "RUQ pain",
  [GynecologicalPhysicalExamCodes.LUQPain]: "LUQ pain",
  [GynecologicalPhysicalExamCodes.LLQPain]: "LLQ pain",
  [GynecologicalPhysicalExamCodes.RLQPain]: "RLQ pain",
  [GynecologicalPhysicalExamCodes.AbdominalTenderness]: "Abdominal tenderness",
  [GynecologicalPhysicalExamCodes.Hepatomegaly]: "Hepatomegaly",
  [GynecologicalPhysicalExamCodes.Splenomegaly]: "Splenomegaly",
  [GynecologicalPhysicalExamCodes.RigidAbdomen]: "Rigid abdomen",
  [GynecologicalPhysicalExamCodes.MassesPresent]: "Masses present",
  [GynecologicalPhysicalExamCodes.Guarding]: "Guarding",
  [GynecologicalPhysicalExamCodes.UmbilicalHernia]: "Umbilical hernia",
  [GynecologicalPhysicalExamCodes.InguinalHernia]: "Inguinal hernia",
  [GynecologicalPhysicalExamCodes.DiastasisRecti1cm]: "Diastasis recti 1cm",
  [GynecologicalPhysicalExamCodes.DiastasisRecti2cm]: "Diastasis recti 2cm",
  [GynecologicalPhysicalExamCodes.DiastasisRecti3cm]: "Diastasis recti 3cm",
  [GynecologicalPhysicalExamCodes.DiastasisRecti4PlusCm]: "Diastasis recti 4+cm",
  [GynecologicalPhysicalExamCodes.CSIncisionNotApproximated]: "C/S incision not approximated",
  [GynecologicalPhysicalExamCodes.CSIncisionDischarge]: "C/S incision with discharge",
  [GynecologicalPhysicalExamCodes.CSIncisionOdor]: "C/S incision with odor",
  [GynecologicalPhysicalExamCodes.CSIncisionPain]: "C/S incision pain",
  [GynecologicalPhysicalExamCodes.NoHemorrhoids]: "No hemorrhoids",
  [GynecologicalPhysicalExamCodes.NoFissures]: "No fissures",
  [GynecologicalPhysicalExamCodes.NoLesions]: "No lesions",
  [GynecologicalPhysicalExamCodes.Hemorrhoids]: "Hemorrhoids",
  [GynecologicalPhysicalExamCodes.Fissure]: "Fissure",
  [GynecologicalPhysicalExamCodes.Lesions]: "Lesions",
  [GynecologicalPhysicalExamCodes.NoLesionsGeneral]: "No lesions",
  [GynecologicalPhysicalExamCodes.NoVaricosities]: "No varicosities",
  [GynecologicalPhysicalExamCodes.NoEdema]: "No edema",
  [GynecologicalPhysicalExamCodes.LesionsGeneral]: "Lesions",
  [GynecologicalPhysicalExamCodes.VaricositiesLSide]: "Varicosities L side",
  [GynecologicalPhysicalExamCodes.VaricositiesRSide]: "Varicosities R side",
  [GynecologicalPhysicalExamCodes.UnhealedLabialLaceration]: "Unhealed labial laceration",
  [GynecologicalPhysicalExamCodes.CervixNoTenderness]: "No tenderness",
  [GynecologicalPhysicalExamCodes.CervixNoProlapse]: "No prolapse",
  [GynecologicalPhysicalExamCodes.CervixTenderness]: "Tenderness",
  [GynecologicalPhysicalExamCodes.CervixProlapse]: "Prolapse",
  [GynecologicalPhysicalExamCodes.CervixProlapseToHymen]: "Prolapse to hymen",
  [GynecologicalPhysicalExamCodes.CervixProlapsePastHymen]: "Prolapse past hymen",
  [GynecologicalPhysicalExamCodes.Intact]: "Intact",
  [GynecologicalPhysicalExamCodes.UnhealedClitoralLaceration]: "Unhealed clitoral laceration",
  [GynecologicalPhysicalExamCodes.LabiaMinoraRegressedOrAglutinated]:
    "Labia minora regressed or aglutinated",
  [GynecologicalPhysicalExamCodes.VaginaNoDischarge]: "No discharge",
  [GynecologicalPhysicalExamCodes.VaginaNoProlapse]: "No prolapse",
  [GynecologicalPhysicalExamCodes.VaginaNoGranulationTissue]: "No granulation tissue",
  [GynecologicalPhysicalExamCodes.VaginaDischarge]: "Discharge",
  [GynecologicalPhysicalExamCodes.VaginaCystocele]: "Cystocele",
  [GynecologicalPhysicalExamCodes.VaginaRectocele]: "Rectocele",
  [GynecologicalPhysicalExamCodes.VaginaGranulationTissue]: "Granulation tissue",
  [GynecologicalPhysicalExamCodes.UterusNoTenderness]: "No tenderness",
  [GynecologicalPhysicalExamCodes.UterusInvoluted]: "Involuted",
  [GynecologicalPhysicalExamCodes.UterusTenderness]: "Tenderness",
  [GynecologicalPhysicalExamCodes.UterusNotInvoluted]: "Not involuted",
  [GynecologicalPhysicalExamCodes.UterusBoggy]: "Boggy",
  [GynecologicalPhysicalExamCodes.AdnexaNoPain]: "No pain",
  [GynecologicalPhysicalExamCodes.AdnexaNoMasses]: "No masses",
  [GynecologicalPhysicalExamCodes.AdnexaMass]: "Mass",
  [GynecologicalPhysicalExamCodes.AdnexaMasses]: "Masses",
  [GynecologicalPhysicalExamCodes.AdnexaPain]: "Pain",
  [GynecologicalPhysicalExamCodes.PerineumWellApproximated]: "Well approximated",
  [GynecologicalPhysicalExamCodes.PerineumNoInfection]: "No infection",
  [GynecologicalPhysicalExamCodes.PerineumNoPain]: "No pain",
  [GynecologicalPhysicalExamCodes.PerineumNotApproximated]: "Not approximated",
  [GynecologicalPhysicalExamCodes.PerineumRedness]: "Redness",
  [GynecologicalPhysicalExamCodes.PerineumTenderness]: "Tenderness",
  [GynecologicalPhysicalExamCodes.PerineumSuturesVisible]: "Sutures visible",
  [GynecologicalPhysicalExamCodes.PerineumPain]: "Pain",
  [GynecologicalPhysicalExamCodes.PerineumLacerationNone]: "None",
  [GynecologicalPhysicalExamCodes.PerineumLacerationLabial]: "Labial",
  [GynecologicalPhysicalExamCodes.PerineumLacerationClitoral]: "Clitoral",
  [GynecologicalPhysicalExamCodes.PerineumLacerationFirst]: "First",
  [GynecologicalPhysicalExamCodes.PerineumLacerationSecond]: "Second",
  [GynecologicalPhysicalExamCodes.PerineumLacerationThird]: "Third",
  [GynecologicalPhysicalExamCodes.PerineumLacerationFourth]: "Fourth",
  [GynecologicalPhysicalExamCodes.EpisiotomyTypeMidline]: "Midline",
  [GynecologicalPhysicalExamCodes.EpisiotomyTypeMediolateral]: "Mediolateral",
  [GynecologicalPhysicalExamCodes.EpisiotomyWellApproximated]: "Well approximated",
  [GynecologicalPhysicalExamCodes.EpisiotomyNoInfection]: "No infection",
  [GynecologicalPhysicalExamCodes.EpisiotomyNoPain]: "No pain",
  [GynecologicalPhysicalExamCodes.EpisiotomyNotApproximated]: "Not approximated",
  [GynecologicalPhysicalExamCodes.EpisiotomyRedness]: "Redness",
  [GynecologicalPhysicalExamCodes.EpisiotomyTenderness]: "Tenderness",
  [GynecologicalPhysicalExamCodes.EpisiotomySuturesVisible]: "Sutures visible",
  [GynecologicalPhysicalExamCodes.EpisiotomyPain]: "Pain",
  [PhysicalExamCodes.Normocephalic]: "Normocephalic",
  [PhysicalExamCodes.Atraumatic]: "Atraumatic",
  [PhysicalExamCodes.NoVisibleOrPalpableMassesDepressionsOrScarring]:
    "No visible or palpable masses, depressions, or scarring",
  [PhysicalExamCodes.MassesPresent]: "Masses present",
  [PhysicalExamCodes.ScarringPresent]: "Scarring present",
  [PhysicalExamCodes.ConjunctivaClear]: "Conjunctiva clear",
  [PhysicalExamCodes.ScleraNonIcteric]: "Sclera non-icteric",
  [PhysicalExamCodes.EOMIntact]: "EOM intact",
  [PhysicalExamCodes.PERRL]: "PERRL",
  [PhysicalExamCodes.NoExudatesOrHemorrhages]: "No exudates or hemorrhages",
  [PhysicalExamCodes.VisualAcuityIntact]: "Visual acuity intact",
  [PhysicalExamCodes.WearingGlasses]: "Wearing glasses",
  [PhysicalExamCodes.WearingContactLenses]: "Wearing contact lenses",
  [PhysicalExamCodes.DischargePresent]: "Discharge present",
  [PhysicalExamCodes.IctericSclera]: "Icteric sclera",
  [PhysicalExamCodes.CataractsPresent]: "Cataracts present",
  [PhysicalExamCodes.MissingEyes]: "Missing eye(s)",
  [PhysicalExamCodes.HearingIntact]: "Hearing intact",
  [PhysicalExamCodes.EACsClear]: "EACs clear",
  [PhysicalExamCodes.TympanicMembraneTranslucentMobile]: "Tympanic membrane translucent & mobile",
  [PhysicalExamCodes.NoDeformities]: "No deformities",
  [PhysicalExamCodes.DifficultyHearing]: "Difficulty hearing",
  [PhysicalExamCodes.TympanicMembraneBulging]: "Tympanic membrane bulging",
  [PhysicalExamCodes.ExcessiveEarWaxPresent]: "Excessive ear wax present",
  [PhysicalExamCodes.HearingAidPresent]: "Hearing aid present",
  [PhysicalExamCodes.DeformitiesPresent]: "Deformities present",
  [PhysicalExamCodes.PatentNares]: "Patent nares",
  [PhysicalExamCodes.NoExternalLesions]: "No external lesions",
  [PhysicalExamCodes.MucosaNonInflamed]: "Mucosa non-inflamed",
  [PhysicalExamCodes.StraightSeptum]: "Straight septum",
  [PhysicalExamCodes.FlaringOfNares]: "Flaring of nares",
  [PhysicalExamCodes.DeviatedSeptum]: "Deviated septum",
  [PhysicalExamCodes.NonPatentNare]: "Non-patent nare(s)",
  [PhysicalExamCodes.MucousMembranesPink]: "Mucous membranes pink",
  [PhysicalExamCodes.MucousMembranesMoist]: "Mucous membranes moist",
  [PhysicalExamCodes.NoMucosalLesions]: "No mucosal lesions",
  [PhysicalExamCodes.DryChappedLips]: "Dry/chapped lips",
  [PhysicalExamCodes.LesionOfLips]: "Lesion of lips",
  [PhysicalExamCodes.LesionOfInsideOfMouth]: "Lesion of inside of mouth",
  [PhysicalExamCodes.PallorOfMucousMembranes]: "Pallor of mucous membranes",
  [PhysicalExamCodes.CleftPalate]: "Cleft palate",
  [PhysicalExamCodes.Halitosis]: "Halitosis",
  [PhysicalExamCodes.AllMostTeethPresent]: "All/most teeth present",
  [PhysicalExamCodes.NoObviousCariesOrPeriodontalDisease]:
    "No obvious caries or periodontal disease",
  [PhysicalExamCodes.NoGingivalInflammationOrSignificantResorption]:
    "No gingival inflammation or significant resorption",
  [PhysicalExamCodes.TeethMissing]: "Teeth missing",
  [PhysicalExamCodes.Dentures]: "Dentures",
  [PhysicalExamCodes.BleedingGums]: "Bleeding gums",
  [PhysicalExamCodes.RecedingGums]: "Receding gums",
  [PhysicalExamCodes.NoTonsillarHypertrophyOrExudate]: "No tonsillar hypertrophy or exudate",
  [PhysicalExamCodes.ExudatePresentInPharynx]: "Exudate present in pharynx",
  [PhysicalExamCodes.ExudatePresentOnTonsils]: "Exudate present on tonsils",
  [PhysicalExamCodes.EnlargedTonsils]: "Enlarged tonsils",
  [PhysicalExamCodes.ThyroidNonEnlarged]: "Thyroid non-enlarged",
  [PhysicalExamCodes.ThyroidNonTender]: "Thyroid non-tender",
  [PhysicalExamCodes.ThyroidWithoutMasses]: "Thyroid without masses",
  [PhysicalExamCodes.Supple]: "Supple",
  [PhysicalExamCodes.TracheaMidline]: "Trachea midline",
  [PhysicalExamCodes.NoLesionsBruitsOrAdenopathy]: "No lesions, bruits, or adenopathy",
  [PhysicalExamCodes.ThyroidEnlarged]: "Thyroid enlarged",
  [PhysicalExamCodes.ThyroidNodules]: "Thyroid nodules",
  [PhysicalExamCodes.ThyroidTenderness]: "Thyroid tenderness",
  [PhysicalExamCodes.PainWithMotion]: "Pain with motion",
  [PhysicalExamCodes.NeckTenderness]: "Neck tenderness",
  [PhysicalExamCodes.EnlargedLymphNodes]: "Enlarged lymph nodes",
  [PhysicalExamCodes.Rigid]: "Rigid",
  [PhysicalExamCodes.DeviatedTrachea]: "Deviated trachea",
  [PhysicalExamCodes.WellAppearing]: "Well appearing",
  [PhysicalExamCodes.WellNourished]: "Well nourished",
  [PhysicalExamCodes.WellDeveloped]: "Well developed",
  [PhysicalExamCodes.NoAcuteDistress]: "In no acute distress",
  [PhysicalExamCodes.AlertAndOrientedX3]: "Alert and oriented x 3",
  [PhysicalExamCodes.NormalMoodAffect]: "Normal mood and affect",
  [PhysicalExamCodes.Distressed]: "Distressed",
  [PhysicalExamCodes.Disheveled]: "Disheveled",
  [PhysicalExamCodes.Lethargic]: "Lethargic",
  [PhysicalExamCodes.Underdeveloped]: "Underdeveloped",
  [PhysicalExamCodes.Overdeveloped]: "Overdeveloped",
  [PhysicalExamCodes.NotAlert]: "Not alert",
  [PhysicalExamCodes.NotOrientedTime]: "Not oriented to time",
  [PhysicalExamCodes.NotOrientedPlace]: "Not oriented to place",
  [PhysicalExamCodes.NotOrientedPerson]: "Not oriented to person",
  [PhysicalExamCodes.BreastSmoothSkin]: "Smooth skin",
  [PhysicalExamCodes.BreastNoNippleAbnormality]: "No nipple abnormality",
  [PhysicalExamCodes.BreastNoDistinctMasses]: "No distinct masses",
  [PhysicalExamCodes.BreastNoTendernessToPalpation]: "No tenderness to palpation",
  [PhysicalExamCodes.BreastNoAxillaryAdenopathy]: "No axillary or supraclavicular adenopathy",
  [PhysicalExamCodes.BreastNoNippleDischarge]: "No nipple discharge",
  [PhysicalExamCodes.BreastNoScars]: "No scars",
  [PhysicalExamCodes.BreastNoEngorgement]: "No engorgement",
  [PhysicalExamCodes.BreastCurrentlyBreastfeeding]: "Currently breastfeeding",
  [PhysicalExamCodes.BreastEngorgement]: "Engorgement",
  [PhysicalExamCodes.BreastRedness]: "Redness",
  [PhysicalExamCodes.BreastCrackedNipples]: "Cracked nipples",
  [PhysicalExamCodes.BreastInvertedLNipple]: "Inverted Left nipple",
  [PhysicalExamCodes.BreastInvertedRNipple]: "Inverted right nipple",
  [PhysicalExamCodes.BreastFibrocystic]: "Fibrocystic",
  [PhysicalExamCodes.BreastSkinDimpling]: "Skin dimpling",
  [PhysicalExamCodes.BreastPeauDorange]: "Peau d'orange",
  [PhysicalExamCodes.BreastScarring]: "Scarring",
  [PhysicalExamCodes.BreastMasses]: "Mass(es) (see comments for details)",
  [PhysicalExamCodes.BreastBloodyRNippleDischarge]: "Bloody right nipple discharge",
  [PhysicalExamCodes.BreastGreenYellowRNippleDischarge]: "Green/yellow right nipple discharge",
  [PhysicalExamCodes.BreastClearRNippleDischarge]: "Clear right nipple discharge",
  [PhysicalExamCodes.BreastWhiteMilkyRNippleDischarge]: "White/Milky right nipple discharge",
  [PhysicalExamCodes.BreastBloodyLNippleDischarge]: "Bloody left nipple discharge",
  [PhysicalExamCodes.BreastGreenYellowLNippleDischarge]: "Green/yellow left nipple discharge",
  [PhysicalExamCodes.BreastClearLNippleDischarge]: "Clear left nipple discharge",
  [PhysicalExamCodes.BreastWhiteMilkyLNippleDischarge]: "White/Milky left nipple discharge",
  [PhysicalExamCodes.BreastAxillaryLymphNodesEnlarged]: "Axillary lymph nodes enlarged",
  [PhysicalExamCodes.BreastSupraclavicularLymphNodesEnlarged]:
    "Supraclavicular lymph nodes enlarged",
  [PhysicalExamCodes.DTRsNormal]: "DTRs normal in lower extremities",
  [PhysicalExamCodes.IntactSensations]: "Intact sensations",
  [PhysicalExamCodes.DTRsPlus3]: "+3 DTRs",
  [PhysicalExamCodes.DTRsPlus4]: "+4 DTRs",
  [PhysicalExamCodes.DTRsPlus2]: "+2 DTRs",
  [PhysicalExamCodes.InabilityToDifferentiateHotFromCold]:
    "Inability to differentiate hot from cold",
  [PhysicalExamCodes.InabilityToDifferentiateSharpFromDull]:
    "Inability to differentiate sharp from dull",
  [PhysicalExamCodes.NormalRangeOfMotion]: "Normal range of motion",
  [PhysicalExamCodes.NoSwelling]: "No swelling",
  [PhysicalExamCodes.NoTenderness]: "No tenderness",
  [PhysicalExamCodes.NoCyanosis]: "No cyanosis",
  [PhysicalExamCodes.NoClubbing]: "No clubbing",
  [PhysicalExamCodes.CapillaryRefillLessThan2Seconds]: "Capillary refill < 2 seconds",
  [PhysicalExamCodes.LimitedRangeOfMotion]: "Limited range of motion",
  [PhysicalExamCodes.Swelling]: "Swelling",
  [PhysicalExamCodes.Tenderness]: "Tenderness",
  [PhysicalExamCodes.Deformities]: "Deformities",
  [PhysicalExamCodes.Cyanosis]: "Cyanosis",
  [PhysicalExamCodes.Clubbing]: "Clubbing",
  [PhysicalExamCodes.CapillaryRefillGreaterThan2Seconds]: "Capillary refill > 2 seconds",
  [PhysicalExamCodes.Edema]: "Edema",
  [PhysicalExamCodes.JointStiffness]: "Joint stiffness",
  [PhysicalExamCodes.MuscleWeakness]: "Muscle weakness",
  [PhysicalExamCodes.MuscleAtrophy]: "Muscle atrophy",
  [PhysicalExamCodes.Tremors]: "Tremors",
  [PhysicalExamCodes.VaricoseVeins]: "Varicose veins",
  [PhysicalExamCodes.RegularRateRhythm]: "Regular rate and rhythm",
  [PhysicalExamCodes.NoMurmurGallop]: "No murmur or gallop",
  [PhysicalExamCodes.IrregularRhythm]: "Irregular rhythm",
  [PhysicalExamCodes.IrregularRate]: "Irregular rate",
  [PhysicalExamCodes.MurmurPresent]: "Murmur present",
  [PhysicalExamCodes.ClearToAuscultation]: "Clear to auscultation bilaterally",
  [PhysicalExamCodes.UnlaboredBreathing]: "Unlabored breathing",
  [PhysicalExamCodes.Wheezing]: "Wheezing",
  [PhysicalExamCodes.RalesCrackles]: "Rales/crackles",
  [PhysicalExamCodes.LungsIrregularRate]: "Irregular rate",
  [PhysicalExamCodes.Rhonchi]: "Rhonchi",
  [PhysicalExamCodes.UseOfAccessoryMuscles]: "Use of accessory muscles",
  [PhysicalExamCodes.SkinGoodTurgor]: "Good turgor",
  [PhysicalExamCodes.SkinNoRash]: "No rash",
  [PhysicalExamCodes.SkinNoLesions]: "No lesions",
  [PhysicalExamCodes.SkinNoUnusualBruising]: "No unusual bruising or prominent lesions",
  [PhysicalExamCodes.SkinHairNormalTextureDistribution]: "Hair: Normal texture and distribution",
  [PhysicalExamCodes.SkinNailsNormalColorNoDeformities]: "Nails: Normal color, no deformities",
  [PhysicalExamCodes.SkinNoTattoos]: "No tattoos present",
  [PhysicalExamCodes.SkinNoScars]: "No scars",
  [PhysicalExamCodes.SkinNoPiercings]: "No piercings",
  [PhysicalExamCodes.SkinRashPresent]: "Rash present",
  [PhysicalExamCodes.SkinLesionsPresent]: "Lesions present",
  [PhysicalExamCodes.SkinBruisingPresent]: "Bruising present",
  [PhysicalExamCodes.SkinTattoosPresent]: "Tattoos present",
  [PhysicalExamCodes.SkinPiercingsPresent]: "Piercings present",
  [PhysicalExamCodes.SkinScarsPresent]: "Scars present (see comment)",
  [PhysicalExamCodes.SkinHairLoss]: "Hair loss",
  [PhysicalExamCodes.SkinHirsutism]: "Hirsutism",
  [PhysicalExamCodes.SkinNailsBrittle]: "Nails brittle",
  [PhysicalExamCodes.PsychiatricNormalMoodAffect]: "Normal mood and affect",
  [PhysicalExamCodes.PsychiatricEpds0To6]: "EPDS 0-6",
  [PhysicalExamCodes.PsychiatricPhq9FourOrLess]: "PHQ9: 4 or less",
  [PhysicalExamCodes.PsychiatricIntactRecentRemoteMemory]: "Intact recent and remote memory",
  [PhysicalExamCodes.PsychiatricEpds7To13]: "EPDS 7-13",
  [PhysicalExamCodes.PsychiatricEpds14To19]: "EPDS 14-19",
  [PhysicalExamCodes.PsychiatricEpds19To30]: "EPDS 19-30",
  [PhysicalExamCodes.PsychiatricPhq9FiveToNine]: "PHQ9 score: 5-9",
  [PhysicalExamCodes.PsychiatricPhq9TenToFourteen]: "PHQ9 score: 10-14",
  [PhysicalExamCodes.PsychiatricPhq9FifteenToNineteen]: "PHQ9 score: 15-19",
  [PhysicalExamCodes.PsychiatricPhq9TwentyToTwentySeven]: "PHQ9 score: 20-27",
  [PhysicalExamCodes.PsychiatricAnxious]: "Anxious",
  [PhysicalExamCodes.PsychiatricDepressed]: "Depressed",
  [PhysicalExamCodes.PsychiatricAgitated]: "Agitated",
  [PhysicalExamCodes.PsychiatricHallucinations]: "Hallucinations",
  [PhysicalExamCodes.PsychiatricParanoid]: "Paranoid",
  [PhysicalExamCodes.PsychiatricPoorRecentMemory]: "Poor recent memory",
  [PhysicalExamCodes.PsychiatricPoorRemoteMemory]: "Poor remote memory",
  [PhysicalExamCodes.VulvaNoMasses]: "No vulvar masses",
  [PhysicalExamCodes.VulvaNoLesions]: "No vulvar lesions",
  [PhysicalExamCodes.VulvaNoAtrophy]: "No vulvar atrophy",
  [PhysicalExamCodes.VulvaNoArchitecturalDistortion]: "No architectural distortion",
  [PhysicalExamCodes.VulvaNoScars]: "No scars",
  [PhysicalExamCodes.VulvaNoRashes]: "No rashes",
  [PhysicalExamCodes.VulvaNoHematoma]: "No hematoma",
  [PhysicalExamCodes.VulvaLacerationWellApproximated]: "Laceration/Episiotomy well approximated",
  [PhysicalExamCodes.VulvaMasses]: "Vulvar mass(es)",
  [PhysicalExamCodes.VulvaLesions]: "Vulvar lesions",
  [PhysicalExamCodes.VulvaAtrophy]: "Vulvar atrophy",
  [PhysicalExamCodes.VulvaAgglutination]: "Agglutination of tissue",
  [PhysicalExamCodes.VulvaRash]: "Rash",
  [PhysicalExamCodes.VulvaThickenedSkin]: "Thickened skin",
  [PhysicalExamCodes.VulvaLacerationNotWellApproximated]:
    "Laceration/Episiotomy not well approximated",
  [PhysicalExamCodes.PerineumWellApproximated]: "Well approximated",
  [PhysicalExamCodes.PerineumNotApproximated]: "Not approximated",
  [PhysicalExamCodes.PerineumRedness]: "Redness",
  [PhysicalExamCodes.PerineumTenderness]: "Tenderness",
  [PhysicalExamCodes.PerineumSuturesVisible]: "Sutures visible",
  [PhysicalExamCodes.PerineumPain]: "Pain",
  [PhysicalExamCodes.PerineumNoInfection]: "No infection",
  [PhysicalExamCodes.PerineumNoPain]: "No pain",
  [PhysicalExamCodes.EpisiotomyWellApproximated]: "Well approximated",
  [PhysicalExamCodes.EpisiotomyNotApproximated]: "Not approximated",
  [PhysicalExamCodes.EpisiotomyRedness]: "Redness",
  [PhysicalExamCodes.EpisiotomyTenderness]: "Tenderness",
  [PhysicalExamCodes.EpisiotomySuturesVisible]: "Sutures visible",
  [PhysicalExamCodes.EpisiotomyPain]: "Pain",
  [PhysicalExamCodes.EpisiotomyNoInfection]: "No infection",
  [PhysicalExamCodes.EpisiotomyNoPain]: "No pain",
  [PhysicalExamCodes.None]: "None",
  [PhysicalExamCodes.Labial]: "Labial",
  [PhysicalExamCodes.Clitoral]: "Clitoral",
  [PhysicalExamCodes.FirstDegree]: "1st",
  [PhysicalExamCodes.SecondDegree]: "2nd",
  [PhysicalExamCodes.ThirdDegree]: "3rd",
  [PhysicalExamCodes.FourthDegree]: "4th",
  [PhysicalExamCodes.Midline]: "Midline",
  [PhysicalExamCodes.Mediolateral]: "Mediolateral",
  [PhysicalExamCodes.NoVaricosities]: "No varicosities",
  [PhysicalExamCodes.NoEdema]: "No edema",
  [PhysicalExamCodes.Intact]: "Intact",
  [PhysicalExamCodes.VaricositiesLSide]: "Varicosities L side",
  [PhysicalExamCodes.VaricositiesRSide]: "Varicosities R side",
  [PhysicalExamCodes.UnhealedLabialLaceration]: "Unhealed labial laceration",
  [PhysicalExamCodes.UnhealedClitoralLaceration]: "Unhealed clitoral laceration",
  [PhysicalExamCodes.LabiaMinoraRegressedOrAglutinated]: "Labia minora regressed or aglutinated",
  [PhysicalExamCodes.RectumNoHemorrhoidsOrMasses]: "No hemorrhoids or masses palpable",
  [PhysicalExamCodes.RectumNormalSphincterTone]: "Normal rectal sphincter tone",
  [PhysicalExamCodes.RectumHemorrhoidsPresent]: "Hemorrhoids present",
  [PhysicalExamCodes.RectumMassesPresent]: "Mass(es) present",
  [PhysicalExamCodes.RectumDecreasedSphincterTone]: "Decreased sphincter tone",
  [PhysicalExamCodes.RectumIncreasedSphincterTone]: "Increased sphincter tone",
  [PhysicalExamCodes.AnusNoHemorrhoids]: "No hemorrhoids",
  [PhysicalExamCodes.AnusNoFissures]: "No fissures",
  [PhysicalExamCodes.AnusNoLesions]: "No lesions",
  [PhysicalExamCodes.AnusHemorrhoids]: "Hemorrhoids",
  [PhysicalExamCodes.AnusFissure]: "Fissure",
  [PhysicalExamCodes.AnusLesions]: "Lesions",
  [PhysicalExamCodes.NoLesionsGeneral]: "No lesions",
  [PhysicalExamCodes.LesionsGeneral]: "Lesions",
  [PhysicalExamCodes.VaginaWithoutLesions]: "Vagina without lesions",
  [PhysicalExamCodes.VaginaClearCreamyDischarge]: "Clear/creamy vaginal discharge",
  [PhysicalExamCodes.VaginaNoAtrophy]: "No atrophy",
  [PhysicalExamCodes.VaginaNoPainWithInsertion]: "No pain with insertion",
  [PhysicalExamCodes.VaginaIntactHymen]: "Intact hymen",
  [PhysicalExamCodes.VaginaVestibulitis]: "Vestibulitis",
  [PhysicalExamCodes.VaginaAbnormalDischarge]: "Other abnormal vaginal discharge",
  [PhysicalExamCodes.VaginaThickClumpyDischarge]: "Thick clumpy vaginal discharge",
  [PhysicalExamCodes.VaginaYellowDischarge]: "Yellow vaginal discharge",
  [PhysicalExamCodes.VaginaGreenDischarge]: "Green vaginal discharge",
  [PhysicalExamCodes.VaginaBloodPresent]: "Blood present in vagina",
  [PhysicalExamCodes.VaginaLesions]: "Vaginal lesions",
  [PhysicalExamCodes.VaginaAtrophy]: "Vaginal atrophy (palor, loss of rugae)",
  [PhysicalExamCodes.VaginaPainAtIntroitus]: "Pain at introitus",
  [PhysicalExamCodes.VaginaPainWithDeepPalpation]: "Pain with deep palpation",
  [PhysicalExamCodes.CervixGrosslyNormal]: "Grossly normal and intact",
  [PhysicalExamCodes.CervixOsClosed]: "Os closed",
  [PhysicalExamCodes.CervixWithoutLesions]: "Cervix without lesions",
  [PhysicalExamCodes.CervixWithoutDischarge]: "Cervix without discharge",
  [PhysicalExamCodes.CervixNoMotionTenderness]: "No cervical motion tenderness",
  [PhysicalExamCodes.CervixBloodFromOs]: "Blood coming from cervical os",
  [PhysicalExamCodes.CervixLesions]: "Cervical lesions",
  [PhysicalExamCodes.CervixFriable]: "Friable cervix",
  [PhysicalExamCodes.CervixRed]: "Red cervix",
  [PhysicalExamCodes.CervixDischarge]: "Cervical discharge",
  [PhysicalExamCodes.CervixMotionTenderness]: "Cervical motion tenderness",
  [PhysicalExamCodes.CervixIUDStringsPresent]: "IUD strings present",
  [PhysicalExamCodes.CervixIUDStringsNotPresent]: "IUD strings not present",
  [PhysicalExamCodes.CervixPolypsPresent]: "Polyp(s) present",
  [PhysicalExamCodes.CervixNoTenderness]: "No tenderness",
  [PhysicalExamCodes.CervixNoProlapse]: "No prolapse",
  [PhysicalExamCodes.CervixTenderness]: "Tenderness",
  [PhysicalExamCodes.CervixProlapse]: "Prolapse",
  [PhysicalExamCodes.CervixProlapseToHymen]: "Prolapse to hymen",
  [PhysicalExamCodes.CervixProlapsePastHymen]: "Prolapse past hymen",
  [PhysicalExamCodes.UterusNotEnlarged]: "Not enlarged uterus",
  [PhysicalExamCodes.UterusNontender]: "Nontender uterus",
  [PhysicalExamCodes.UterusNoMasses]: "No masses of uterus",
  [PhysicalExamCodes.UterusMobile]: "Mobile uterus",
  [PhysicalExamCodes.UterusInverted]: "Uterus inverted",
  [PhysicalExamCodes.UterusAnteflexed]: "Anteflexed",
  [PhysicalExamCodes.UterusAnteverted]: "Anteverted",
  [PhysicalExamCodes.UterusRetroflexed]: "Retroflexed",
  [PhysicalExamCodes.UterusRetroverted]: "Retroverted",
  [PhysicalExamCodes.UterusInvoluted]: "Involuted",
  [PhysicalExamCodes.UterusNotInvoluted]: "Not involuted",
  [PhysicalExamCodes.UterusBoggy]: "Boggy",
  [PhysicalExamCodes.UterusNoTenderness]: "No tenderness",
  [PhysicalExamCodes.UterusTenderness]: "Tenderness",
  [PhysicalExamCodes.AdnexaNontender]: "Nontender adnexa",
  [PhysicalExamCodes.AdnexaNotEnlarged]: "Not enlarged adnexa",
  [PhysicalExamCodes.AdnexaNoMasses]: "No adnexal masses",
  [PhysicalExamCodes.AdnexaNoPain]: "No pain",
  [PhysicalExamCodes.AdnexaMass]: "Mass",
  [PhysicalExamCodes.AdnexaMasses]: "Masses",
  [PhysicalExamCodes.AdnexaPain]: "Pain",
  [PhysicalExamCodes.UterusNoLochia]: "No lochia",
  [PhysicalExamCodes.UterusGravid]: "Gravid uterus",
  [PhysicalExamCodes.UterusAbsent]: "Uterus absent",
  [PhysicalExamCodes.UterusEnlarged]: "Uterus enlarged",
  [PhysicalExamCodes.UterusTender]: "Uterus tender",
  [PhysicalExamCodes.UterusWithMasses]: "Uterus with mass(es)",
  [PhysicalExamCodes.UterusPartiallyInverted]: "Uterus partially inverted",
  [PhysicalExamCodes.UterusFixedImmobile]: "Fixed/immobile uterus",
  [PhysicalExamCodes.AdnexalTenderness]: "Adnexal tenderness",
  [PhysicalExamCodes.RightAdnexalTenderness]: "Right Adnexal tenderness",
  [PhysicalExamCodes.LeftAdnexalTenderness]: "Left Adnexal tenderness",
  [PhysicalExamCodes.RightAdnexalMass]: "Right Adnexal Mass",
  [PhysicalExamCodes.LeftAdnexalMass]: "Left Adnexal Mass",
  [PhysicalExamCodes.LochiaRubra]: "Lochia Rubra",
  [PhysicalExamCodes.LochiaSerosa]: "Lochia Serosa",
  [PhysicalExamCodes.LochiaAlba]: "Lochia Alba",
  [PhysicalExamCodes.PelvicFloorNoCystocele]: "No cystocele",
  [PhysicalExamCodes.PelvicFloorNoRectocele]: "No rectocele",
  [PhysicalExamCodes.PelvicFloorNoProlapse]: "No prolapse",
  [PhysicalExamCodes.PelvicFloorNoPainWithInsertion]: "No pain with insertion",
  [PhysicalExamCodes.PelvicFloorNoPainWithPalpation]: "No pain with deep palpation",
  [PhysicalExamCodes.PelvicFloorPainAtIntroitus]: "Pain at introitus",
  [PhysicalExamCodes.PelvicFloorPainWithDeepPalpation]: "Pain with deep palpation",
  [PhysicalExamCodes.PelvicFloorCystocele]: "Cystocele",
  [PhysicalExamCodes.PelvicFloorRectocele]: "Rectocele",
  [PhysicalExamCodes.PelvicFloorProlapse]: "Prolapse",
  [PhysicalExamCodes.PelvicFloorProlapseGrade1]: "Prolapse grade 1",
  [PhysicalExamCodes.PelvicFloorProlapseGrade2]: "Prolapse grade 2",
  [PhysicalExamCodes.PelvicFloorProlapseGrade3]: "Prolapse grade 3",
  [PhysicalExamCodes.PelvicFloorProlapseGrade4]: "Prolapse grade 4",
  [PhysicalExamCodes.PelvicFloorBladderPain]: "Bladder pain with internal palpation",
  [PhysicalExamCodes.PelvicFloorDifficultySqueezing]: "Difficulty squeezing with muscles",
  [PhysicalExamCodes.PelvicFloorDifficultyPushing]: "Difficulty pushing out with muscles",
  [PhysicalExamCodes.PelvicFloorNoPainAtIntroitus]: "No pain at introitus",
  [PhysicalExamCodes.PelvicFloorNoBladderPain]: "No bladder pain with internal palpation",
  [PhysicalExamCodes.PelvicFloorEasySqueezing]: "Easy squeezing with muscles",
  [PhysicalExamCodes.BowelSoundsAllQuadrants]: "Bowel sounds in all 4 quadrants",
  [PhysicalExamCodes.NoTendernessRUQ]: "No tenderness in RUQ",
  [PhysicalExamCodes.NoTendernessLUQ]: "No tenderness in LUQ",
  [PhysicalExamCodes.NoTendernessRLQ]: "No tenderness in RLQ",
  [PhysicalExamCodes.NoTendernessLLQ]: "No tenderness in LLQ",
  [PhysicalExamCodes.AbdomenSoft]: "Abdomen soft",
  [PhysicalExamCodes.NoOrganomegaly]: "No organomegaly",
  [PhysicalExamCodes.NoMassesAbdomen]: "No masses",
  [PhysicalExamCodes.NoHernia]: "No hernia",
  [PhysicalExamCodes.NoDiastasisRecti]: "No diastasis recti",
  [PhysicalExamCodes.NoDistention]: "No distention",
  [PhysicalExamCodes.CSIncisionWellApproximated]: "C/S incision well approximated",
  [PhysicalExamCodes.DiminishedBowelSounds]: "Diminished bowel sounds",
  [PhysicalExamCodes.RUQPain]: "RUQ pain",
  [PhysicalExamCodes.LUQPain]: "LUQ pain",
  [PhysicalExamCodes.LLQPain]: "LLQ pain",
  [PhysicalExamCodes.RLQPain]: "RLQ pain",
  [PhysicalExamCodes.AbdominalTenderness]: "Abdominal tenderness",
  [PhysicalExamCodes.Hepatomegaly]: "Hepatomegaly",
  [PhysicalExamCodes.Splenomegaly]: "Splenomegaly",
  [PhysicalExamCodes.RigidAbdomen]: "Rigid abdomen",
  [PhysicalExamCodes.Guarding]: "Guarding",
  [PhysicalExamCodes.UmbilicalHernia]: "Umbilical hernia",
  [PhysicalExamCodes.InguinalHernia]: "Inguinal hernia",
  [PhysicalExamCodes.CSIncisionNotApproximated]: "C/S incision not approximated",
  [PhysicalExamCodes.CSIncisionDischarge]: "C/S incision with discharge",
  [PhysicalExamCodes.CSIncisionOdor]: "C/S incision with odor",
  [PhysicalExamCodes.CSIncisionPain]: "C/S incision pain",
  [PhysicalExamCodes.NoCVA]: "No CVA tenderness",
  [PhysicalExamCodes.SpineNormal]: "Spine normal without deformity or tenderness",
  [PhysicalExamCodes.RightCVATenderness]: "Right CVA tenderness",
  [PhysicalExamCodes.LeftCVATenderness]: "Left CVA tenderness",
  [PhysicalExamCodes.Scoliosis]: "Curvature of the spine (scoliosis)",
  [PhysicalExamCodes.Kyphosis]: "Kyphosis",
  [PhysicalExamCodes.Lordosis]: "Lordosis",
  [PhysicalExamCodes.NormalGaitStation]: "Normal gait and station",
  [PhysicalExamCodes.NoAsymmetry]: "No asymmetry",
  [PhysicalExamCodes.NoDefects]: "No defects",
  [PhysicalExamCodes.NoTendernessMusculoskeletal]: "No tenderness",
  [PhysicalExamCodes.NoMassesMusculoskeletal]: "No masses",
  [PhysicalExamCodes.NoEffusions]: "No effusions",
  [PhysicalExamCodes.NoDecreasedRangeOfMotion]: "No decreased range of motion",
  [PhysicalExamCodes.NoInstability]: "No instability",
  [PhysicalExamCodes.NoAbnormalStrengthTone]: "No abnormal strength or tone",
  [PhysicalExamCodes.PainOfPalpation]: "Pain of palpation",
  [PhysicalExamCodes.PainWithMovement]: "Pain with movement",
  [PhysicalExamCodes.Asymmetry]: "Asymmetry",
  [PhysicalExamCodes.AbnormalGait]: "Abnormal gait",
  [PhysicalExamCodes.Limp]: "Limp",
  [PhysicalExamCodes.DecreasedRangeOfMotion]: "Decreased range of motion",
  [PhysicalExamCodes.UseOfWalkingAids]: "Use of walking aids",
  [PhysicalExamCodes.MuscularAtrophy]: "Muscular atrophy",
  [PhysicalExamCodes.Defect]: "Defect",
  [PhysicalExamCodes.Amputation]: "Amputation",
} as const;

export enum PhysicalExamTypes {
  HEENT = "heent",
  GeneralAppearance = "general-appearance",
  Breast = "breast",
  Extremities = "extremities",
  Neurologic = "neurologic",
  Heart = "heart",
  Lungs = "lungs",
  Genitourinary = "genitourinary",
  Abdomen = "abdomen",
  Back = "back",
  Skin = "skin",
  Psychiatric = "psychiatric",
  Musculoskeletal = "musculoskeletal",
  PerineumAndExternalGenitalia = "perineum-and-external-genitalia",
  PostpartumNeck = "postpartum-neck",
  PostpartumAbdomen = "postpartum-abdomen",
  GynecologicalAbdomen = "gynecological-abdomen",
  GynecologicalNeck = "gynecological-neck",
  GynecologicalPerineumAndExternalGenitalia = "gynecological-perineum-and-external-genitalia",
}
